<template>
  <div class="detail houses-detail" ref="housesDetail">
    <div class="detail-center">
      <!-- 头部 -->
      <header>
        <div style="display: flex; align-items: center">
          <a-icon type="left-circle" class="btn_back" theme="twoTone" @click="$router.back()" />
          <!-- <a-icon type="left-circle" class="btn_back" theme="twoTone" @click="$router.go(-1)" /> -->
          <!-- <img class="btn_back" :src="$backSvg" alt="back"></img> -->
          <h2 class="title">房源/出租详情</h2>
          <!-- 【{{ HousesData.shopName }}】 -->
          <!-- <a-icon type="left-circle" style="font-size: 20px; margin-left: 10px" @click="$router.back()" /> -->
        </div>
        <!-- 图标 -->
        <div class="houseBtn">
          <a-button
            style="border: none; background-color: #fff; padding: 0px"
            class="icon"
            @click="visible = true"
            v-if="HousesData.dishType !== '1'"
          >
            <!-- :disabled="HousesData.dishType === 1" -->
            <div class="icon-i icon-ii" :class="{ unclickBgc: HousesData.dishType === '1' }">
              <i class="iconfont icon-bianji1"></i>
            </div>
            <span class="color31c170" :class="{ unclickColor: HousesData.dishType === '1' }">认领</span>
          </a-button>

          <template v-if="HousesData.dishType">
            <template v-if="HousesData.accendantId === uid">
              <div class="btnHouse" @click="handleLook">
                <div class="Claim">
                  <i class="iconfont icon-chakan"></i>
                </div>
                <div class="clainFont">查看</div>
              </div>
            </template>
            <template v-else>
              <div
                class="btnHouse"
                @click="handleLook"
                v-hasPermi="['houses:lessorInfo:query']"
              >
                <div class="Claim">
                  <i class="iconfont icon-chakan"></i>
                </div>
                <div class="clainFont">查看</div>
              </div>
            </template>
            <div class="btnHouse" @click="getEditHouseInfoStatus(1)" v-if="HousesData.accendantId === uid && HousesData.houseStatus !== '1'">
              <div class="Claim">
                <img class="btn_svg" :src="$validSvg" alt="上架" />
              </div>
              <div class="clainFont">上架</div>
            </div>
            <div class="btnHouse" @click="getEditHouseInfoStatus(6)" v-if="HousesData.accendantId === uid &&HousesData.houseStatus !== '6'">
              <div class="Claim">
                <img class="btn_svg" :src="$invalidSvg" alt="下架"/>
              </div>
              <div class="clainFont">下架</div>
            </div>

            <!-- <div @click="getEditHouseInfoStatus(1)" v-if="HousesData.houseStatus !== '1'" class="btn_more">
              上架
            </div>
            <a-divider style="margin: 9px 0" v-if="HousesData.houseStatus !== '1'" />

            <div @click="getEditHouseInfoStatus(6)" v-if="HousesData.houseStatus !== '6'" class="btn_more" >
              下架
            </div>
            <a-divider v-if="HousesData.houseStatus !== '6'" style="margin: 9px 0" /> -->
          </template>

          <template v-if="HousesData.dishType === '1'">
            <div class="btnHouse" @click="edit" v-if="HousesData.accendantId === uid">
              <!-- v-hasPermi="['houses:houseInfo:edit']" -->
              <div class="Claim">
                <i class="iconfont icon-bianji1"></i>
              </div>
              <div class="clainFont">编辑</div>
            </div>

            <div class="btnHouse" @click="followFn" v-if="HousesData.accendantId === uid">
              <div class="Claim">
                <i class="iconfont icon-genjin"></i>
              </div>
              <div class="clainFont">写跟进</div>
            </div>

            <div class="btnHouse">
              <a-popover
                placement="bottomRight"
                v-model="ModleVisible"
                trigger="click">
                <a slot="content" @click="ModleVisible = false">
                  <div class="btn_more" style="width: 150px">更多</div>

                  <template v-if="HousesData.accendantId === uid" v-hasPermi="['houses:lessorInfo:query']">
                    <a-divider style="margin: 9px 0" />
                    <div v-if="HousesData.identityKey === 'N'" class="btn_more" @click="showuploadmoadl(6)">
                      上传钥匙
                    </div>
                    <div v-else class="btn_more" @click="showuploadmoadl(6)">
                      <span></span> 交接钥匙
                    </div>
                    <a-divider style="margin: 9px 0" />
                    <div v-if="HousesData.isEntrust === 'N'" class="btn_more" @click="showuploadmoadl(7)" >
                      上传委托
                    </div>
                    <a-divider v-if="HousesData.isEntrust === 'N'" style="margin: 9px 0" />

                    <div @click="Editor(1, '转维护人')" class="btn_more" v-hasPermi="['houses:houseInfo:accendant']" >
                      转维护人
                    </div>
                    <a-divider style="margin: 9px 0" v-hasPermi="['houses:houseInfo:accendant']"/>

                    <div @click="getEditHouseInfoStatus(3)" v-if="HousesData.houseStatus !== '3'" class="btn_more">
                      自行成交
                    </div>
                    <a-divider style="margin: 9px 0" v-if="HousesData.houseStatus !== '3'" />

                    <div @click="getEditHouseInfoStatus(4)" v-if="HousesData.houseStatus !== '4'" class="btn_more">
                      无效
                      <!-- 转为错误 -->
                    </div>
                    <a-divider style="margin: 9px 0" v-if="HousesData.houseStatus !== '4'" />

                    <!-- <div @click="getEditHouseInfoStatus(5)" v-if="HousesData.houseStatus !== '5'" class="btn_more">
                      无效
                      不租
                    </div>
                    <a-divider style="margin: 9px 0" v-if="HousesData.houseStatus !== '5'"/> -->

                    <div
                      class="btn_more"
                      @click="editIdentityHandle('1', HousesData.identityFive)"
                      v-if="HousesData.accendantId === uid && HousesData.dishType === '1'"
                    >
                      <span v-if="HousesData.identityFive === 'Y'">
                        取消五房
                      </span>
                      <span v-else>
                        点亮五房
                      </span>
                    </div>
                    <a-divider v-if="HousesData.accendantId === uid && HousesData.dishType === '1'" style="margin: 9px 0" />

                    <div
                      class="btn_more"
                      @click="editIdentityHandle('3', HousesData.identityExcellent)"
                      v-if="HousesData.accendantId === uid && HousesData.dishType === '1'"
                    >
                      <span v-if="HousesData.identityExcellent === 'Y'">
                        取消优质
                      </span>
                      <span v-else>
                        点亮优质
                      </span>
                    </div>
                    <a-divider v-if="HousesData.accendantId === uid && HousesData.dishType === '1'" style="margin: 9px 0" />
                    <div @click="getSynchronization" style="color: black; text-align: center">一键同步</div>

                  </template>
                  <template>
                    <a-divider
                      v-hasPermi="['house:houseInfo:only']"
                      style="margin: 9px 0" />
                    <div
                      v-hasPermi="['house:houseInfo:only']"
                      class="btn_more"
                      @click="editIdentityHandle('2', HousesData.identityAlone)">
                      <span v-if="HousesData.identityAlone === 'Y'">
                        取消独家
                      </span>
                      <span v-else>
                        点亮独家
                      </span>
                    </div>

                    <!-- <a-divider v-show="HousesData.accendantId === uid && HousesData.dishType === '1'" style="margin: 9px 0" />
                    <div v-show="HousesData.accendantId === uid && HousesData.dishType === '1'" class="btn_more" @click="editIdentityHandle('2', HousesData.identityAlone)">
                      <span v-if="HousesData.identityAlone === 'Y'">
                        取消独家
                      </span>
                      <span v-else>
                        点亮独家
                      </span>
                    </div> -->
                  </template>

                </a>

                <div class="gdicon">
                  <div class="Moeldtb">
                    <i class="iconfont icon-gengduo"></i>
                  </div>
                  <div class="Moeld">更多</div>
                </div>
              </a-popover>
            </div>
          </template>
        </div>
      </header>
      <!--  切换标题-->
      <aside>
        <div class="card-container">
          <a-tabs default-active-key="1" @change="getTabs" type="card">
            <a-tab-pane key="1" tab="基本信息">
              <div class="basicInfor">
                <div class="basicInfor_left">
                  <div v-if="skImgList && skImgList.length > 0">
                    <!-- 轮播图 -->
                    <div class="swiper_wrapper_con">
                      <div class="box">
                        <div class="swiper-box">
                          <swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop">
                            <swiper-slide v-for="item in skImgList" :key="item.id">
                              <div class="swiper-item" style="width: 100%; height: 100%">
                                <div class="swiper-img" style="width: 100%; height: 100%">
                                  <video
                                    class="swiper-show_video"
                                    v-if="item.fileSuffix==='.mp4'"
                                    :src="imgPrefix + item.fileName"
                                    controls="controls"
                                    @click.stop="previewSwiperImg(imgPrefix + item.fileName,'video')">该内容不支持播放</video>
                                  <img
                                    v-else
                                    class="swiper-show_img"
                                    :src="imgPrefix + item.fileName"
                                    style="width: 100%; height: 100%; object-fit: contain;background-color:#000;"
                                    alt=""
                                    @click.stop="previewSwiperImg(imgPrefix + item.fileName,'img')"
                                  />
                                </div>
                              </div>
                            </swiper-slide>
                          </swiper>
                          <swiper
                            :options="swiperOptionThumbs"
                            class="gallery-thumbs"
                            ref="swiperThumbs"
                            style="margin-top: 20px"
                          >
                            <swiper-slide v-for="(item, index) in skImgList" :key="index">
                              <video class="swiper-show_video" v-if="item.fileSuffix==='.mp4'" :src="imgPrefix + item.fileName" controls="controls"> 该内容不支持播放</video>
                              <img class="swiper-show_img" v-else :src="imgPrefix + item.fileName" style="" />
                            </swiper-slide>
                            <div class="swiper-thumbs-prev swiper-button-white" slot="button-prev">
                              <svg
                                t="1632625518037"
                                class="icon"
                                viewBox="0 0 1024 1024"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                p-id="3165"
                                width="32"
                                height="32"><path d="M731.733333 480l-384-341.333333c-17.066667-14.933333-44.8-14.933333-59.733333 4.266666-14.933333 17.066667-14.933333 44.8 4.266667 59.733334L640 512 292.266667 821.333333c-17.066667 14.933333-19.2 42.666667-4.266667 59.733334 8.533333 8.533333 19.2 14.933333 32 14.933333 10.666667 0 19.2-4.266667 27.733333-10.666667l384-341.333333c8.533333-8.533333 14.933333-19.2 14.933334-32s-4.266667-23.466667-14.933334-32z" p-id="3166" fill="#999999"></path></svg>
                            </div>
                            <div class="swiper-thumbs-next swiper-button-white" slot="button-next">
                              <svg
                                t="1632625587130"
                                class="icon"
                                viewBox="0 0 1024 1024"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                p-id="3459"
                                width="32"
                                height="32"><path d="M384 512L731.733333 202.666667c17.066667-14.933333 19.2-42.666667 4.266667-59.733334-14.933333-17.066667-42.666667-19.2-59.733333-4.266666l-384 341.333333c-10.666667 8.533333-14.933333 19.2-14.933334 32s4.266667 23.466667 14.933334 32l384 341.333333c8.533333 6.4 19.2 10.666667 27.733333 10.666667 12.8 0 23.466667-4.266667 32-14.933333 14.933333-17.066667 14.933333-44.8-4.266667-59.733334L384 512z" p-id="3460" fill="#999999"></path></svg>
                            </div>
                          </swiper>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="no_img_wrapper" v-else>
                    <div class="no_img">
                      <img src="../../../../assets/images/nodataImg.svg" alt="" />
                    </div>
                    暂无实勘,去<a-button type="link" @click="addImg('add')">上传</a-button>
                  </div>
                  <span v-if="skImgList && skImgList.length > 0" class="botText">
                    <p>共{{ skImgList ? skImgList.length : 0 }}张照片</p>
                    <p style="cursor: pointer" @click="showDownloadFile">下载图片</p>、
                    <!-- 当前登录为维护人或维护人所在店的店长 -->
                    <p v-if=" HousesData.accendantStoreLeaderId=== uid || HousesData.accendantId === uid" @click="EditImg('edit')" style="cursor: pointer">编辑图片</p>
                  </span>
                </div>
                <div class="basicInfor_right basicNew">
                  <div class="basicTelte">
                    <div class="house-basicInfoR-warpper">
                      <span class="shop_name">{{ HousesData.shopName }}
                        <!-- <a-tag class="tag_house_status" color="var(--ThemeColor)" v-if="HousesData.houseStatus === '1'">有效 </a-tag>
                        <a-tag class="tag_house_status" color="var(--ThemeColor)" v-if="HousesData.houseStatus === '2'">我租 </a-tag>
                        <a-tag class="tag_house_status" color="var(--ThemeColor)" v-if="HousesData.houseStatus === '3'">已租 </a-tag>
                        <a-tag class="tag_house_status" color="var(--ThemeColor)" v-if="HousesData.houseStatus === '4'">错误 </a-tag>
                        <a-tag class="tag_house_status" color="var(--ThemeColor)" v-if="HousesData.houseStatus === '5'">不租 </a-tag> -->
                        <a-tag class="tag_house_status" color="var(--ThemeColor)" v-if="HousesData.houseStatus === '1'">有效 </a-tag>
                        <a-tag class="tag_house_status" color="var(--ThemeColor)" v-if="HousesData.houseStatus === '2'">我司成交 </a-tag>
                        <a-tag class="tag_house_status" color="var(--ThemeColor)" v-if="HousesData.houseStatus === '3'">自行成交 </a-tag>
                        <a-tag class="tag_house_status" color="var(--ThemeColor)" v-if="HousesData.houseStatus === '4'">无效 </a-tag>
                        <a-tag class="tag_house_status" color="var(--ThemeColor)" v-if="HousesData.houseStatus === '5'">无效 </a-tag>
                      </span>
                      <div class="price">
                        <div class="priceInfor">
                          <div class="priceHousin">
                            {{ HousesData.rentFee || '--' }}元/月
                          </div>
                          <div
                            class="priceTag"
                            v-if="
                              HousesData.beforeRentFee && Number(HousesData.rentFee) - HousesData.beforeRentFee != 0
                            "
                          >
                            {{ Math.abs(HousesData.beforeRentFee - Number(HousesData.rentFee)) }}
                            <a-icon
                              v-if="
                                Number(HousesData.rentFee) - HousesData.beforeRentFee > 0 && HousesData.beforeRentFee
                              "
                              type="arrow-up"
                              style="font-size: 12px; color: #fff"
                            >
                            </a-icon>
                            <a-icon
                              v-else-if="
                                HousesData.beforeRentFee && HousesData.beforeRentFee - Number(HousesData.rentFee) > 0
                              "
                              type="arrow-down"
                              style="font-size: 12px; color: #fff"
                            >
                            </a-icon>
                          </div>
                          <div v-else class="priceTag">无变更</div>

                          <div class="price_transferFee"><span>转让费：</span><span>{{ HousesData.transferFee || '--' }}万元</span></div>
                        </div>
                      </div>
                      <div class="dish_tag_area_floor">
                        <div class="dish_tag">
                          <a-tag class="dish_type" color="green" >
                            {{ HousesData.dishType | filterDict(dishTypeOpts) }}
                          </a-tag>
                          <a-tag color="green" v-if="HousesData.isCatering === 'Y' && HousesData.alloweCateringTypeId">
                            {{ HousesData.alloweCateringTypeId | filterDict(repastTypeOpts) }}
                          </a-tag>
                          <a-tag color="green" v-else>
                            <div><span>拒餐饮</span></div>
                          </a-tag>
                        </div>
                        <div class="housArea">
                          <div class="areaInfor">
                            建：{{ HousesData.grossFloorArea }}m²，实：{{ HousesData.saleableArea }}m²
                          </div>
                          <div class="houseup">{{ HousesData.houseFloor }}层，共{{ HousesData.floorTotal }}层</div>
                        </div>
                      </div>

                      <div class="house_special">
                        <div class="basicTelteTu">
                          <div class="detail-t">
                            <span :class="{font_light: HousesData.identityAlone == 'Y',font_gray: HousesData.identityAlone != 'Y'}">
                              独
                            </span>
                          </div>
                          <div class="detail-t" >
                            <span :class="{ font_light: HousesData.identityFive == 'Y',font_gray: HousesData.identityFive != 'Y' }">
                              五
                            </span >
                          </div>
                          <div class="detail-t" >
                            <span :class="{ font_light: HousesData.identityExcellent == 'Y', font_gray: HousesData.identityExcellent != 'Y' }" >
                              优
                            </span>
                          </div>
                          <div class="detail-t">
                            <span class="iconfont icon-yuechi" :class="{ font_light: HousesData.identityKey == 'Y', font_gray: HousesData.identityKey != 'Y'}" style="cursor: unset"></span>
                          </div>
                        </div>
                      </div>
                      <a-divider />
                      <div class="houseInfor">
                        <div class="address">
                          <div class="housin">
                            <!-- 城东，建设路，建设南街 -->
                            {{ HousesData.districtName }},{{ HousesData.businessDistrictName }},{{ HousesData.streetName }}
                            <!-- 放开房源门牌号限制 -->
                            <!-- <span v-if="HousesData.accendantId === uid && HousesData.dishType === '1'"> -->
                            <span>
                              ,{{ HousesData.houseNumber }}号
                              {{ HousesData.houseNumberDeputy ? ',' + HousesData.houseNumberDeputy : '' }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="list_info">
                        <dl class="item_info">
                          <dt class="item_info_name">小区名称：</dt><dd class="item_info_val">{{ HousesData.communityName }}</dd>
                        </dl>
                        <dl class="item_info">
                          <dt class="item_info_name">商铺配套：</dt>
                          <dd class="item_info_val">{{ HousesData.shopAncillary ? HousesData.shopAncillary.split(',').join("、") :'暂无' }}</dd>
                        </dl>
                        <dl class="item_info">
                          <dt class="item_info_name">客流人群：</dt>
                          <dd class="item_info_val">{{ HousesData.trafficCrowd }}</dd>
                        </dl>
                        <dl class="item_info">
                          <dt class="item_info_name">可经营行业：</dt>
                          <dd class="item_info_val">
                            <a-tag v-for="(item,index) in industryCategoryJsonName" :key="'class_'+index">{{ item }}</a-tag>
                            <a-tag v-for="(sub,subIdx) in industrySubclassJsonName" :key="'bub_'+subIdx">{{ sub }}</a-tag>
                          </dd>
                        </dl>
                        <dl class="item_info">
                          <dt class="item_info_name">经营状态：</dt>
                          <dd class="item_info_val"> {{ HousesData.operatingStatusId | filterDict(operatingStatusOpts) }}</dd>
                        </dl>
                        <dl class="item_info">
                          <dt class="item_info_name">委    托：</dt>
                          <dd class="item_info_val">
                            <p v-if="HousesData.isEntrust === 'N'" tyle="display: flex; margin-right: 3px">
                              暂无委托，<a-button type="link" @click="showuploadmoadl(7)">上传</a-button>
                            </p>
                            <p v-else>已上传委托
                              <a-button v-if="HousesData.accendantId !== uid" v-hasPermi="['houses:houseInfo:viewEntrust']" @click="viewEntrust" type="link">查看</a-button>
                              <a-button v-if="HousesData.accendantId === uid" @click="viewEntrust" type="link">查看</a-button>
                            </p>
                          </dd>
                        </dl>
                        <dl class="item_info">
                          <dt class="item_info_name">钥    匙：</dt>
                          <dd class="item_info_val">
                            <p v-if="HousesData.identityKey == 'N'" tyle="display: flex; margin-right: 3px">
                              暂无钥匙，<a-button type="link" @click="showuploadmoadl(6, 'add')">上传钥匙</a-button>
                            </p>
                            <p v-else>
                              {{ HousesData.keyTeamName }},{{ HousesData.keyUserName }}
                              <a-button type="link" @click="showuploadmoadl(6, 'edit')">交接钥匙</a-button>
                            </p>
                          </dd>
                        </dl>
                      </div>

                    </div>

                  </div>
                  <div class="houseTag">
                    <!-- 自定义标签 -->
                    <a-tag color="yellow" v-if="HousesData.tagsContentArray">
                      {{ HousesData.tagsContentArray.split(',')[0] }}
                    </a-tag>
                  </div>

                  <div class="follow-up" v-if="newFollowUpMsg && newFollowUpMsg.createByName">
                    <h1 class="title">最新跟进：</h1>
                    <div class="msg">
                      <div>
                        <h1>{{ newFollowUpMsg.createByName }}</h1>
                        <p>{{ newFollowUpMsg.createTime }}</p>
                      </div>
                      <div class="describe">
                        {{ newFollowUpMsg.recordContent }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="inforCenter">
                <p>
                  其他信息
                  <a-icon :type="showOtherInfo ? 'down-circle' : 'right-circle'" style="font-size: 20px; margin-left: 10px" @click="showHideOtherInfo" />
                </p>
                <div class="botInfo" v-show="showOtherInfo">
                  <a-row>
                    <a-col :span="6">
                      <p>商铺类型</p>
                      <p>
                        {{ HousesData.shopTypeId | filterDict(shopTypeOpts) }}
                      </p>
                    </a-col>
                    <a-col :span="6">
                      <p>商铺性质</p>
                      <p>
                        {{ HousesData.shopNatureId | filterDict(shopNatureOpts) }}
                      </p>
                    </a-col>
                    <!-- <a-col :span="6">
                      <p>经营状态</p>
                      <p>
                        {{ HousesData.operatingStatusId | filterDict(operatingStatusOpts) }}
                      </p>
                    </a-col> -->
                    <a-col :span="6">
                      <p>历史经营</p>
                      <p v-if="HousesData.industryCategoryName == null">--</p>
                      <p v-else>
                        {{ HousesData.industryCategoryName + '-' + HousesData.industrySubclassName }}
                      </p>
                    </a-col>
                    <a-col :span="6">
                      <p>产权性质</p>
                      <p>
                        {{ HousesData.propertyNatureId | filterDict(proppertyNatureOpts) }}
                      </p>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="6">
                      <p>建筑面积</p>
                      <p>{{ HousesData.grossFloorArea }}m²</p>
                    </a-col>
                    <a-col :span="6">
                      <p>实用面积</p>
                      <p>{{ HousesData.saleableArea }}m²</p>
                    </a-col>
                    <a-col :span="6">
                      <p>面宽，层高，进深</p>
                      <p>{{ HousesData.houseWide }}m,{{ HousesData.houseHigh }}m,{{ HousesData.houseLong }}m</p>
                    </a-col>
                    <!-- <a-col :span="6">
                      <p>商户配套</p>
                      <p>
                        {{ HousesData.shopAncillary }}
                      </p>
                    </a-col> -->
                    <a-col :span="6">
                      <p>可否餐饮</p>
                      <p>
                        {{ HousesData.isCatering | filterDict(weatherOpts) }}
                      </p>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="6">
                      <p>是否临街</p>
                      <p>
                        {{ HousesData.isFrontage | filterDict(weatherOpts) }}
                      </p>
                    </a-col>
                    <a-col :span="6">
                      <p>支付方式</p>
                      <p>{{ HousesData.paymentMethod | fiflterYF }}</p>
                    </a-col>
                    <!-- <a-col :span="6">
                      <p>客流人群</p>
                      <p>
                        {{ HousesData.trafficCrowd }}
                      </p>
                    </a-col> -->
                    <a-col :span="6">
                      <p>转让费</p>
                      <p>{{ HousesData.transferFee }}万元</p>
                    </a-col>
                    <a-col :span="6">
                      <p>佣金</p>
                      <p>{{ HousesData.houseBrokerage }}元</p>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="6">
                      <p>递增</p>
                      <p>{{ HousesData.progressiveIncrease }}</p>
                    </a-col>
                    <a-col :span="6">
                      <p>租金</p>
                      <p>
                        {{ HousesData.rentFee }}元/月,{{ HousesData.rentFeeCentiare }}元/m²/月,
                        {{ (parseFloat(HousesData.rentFeeCentiare) / 30).toFixed(2) }}元/m²/天
                      </p>
                    </a-col>
                    <a-col :span="6">
                      <p>相关物业</p>
                      <p>
                        物业费{{ HousesData.propertyFee }}元，电费{{ HousesData.electricityFee }}元/度，水费{{
                          HousesData.waterFee
                        }}元/吨
                      </p>
                    </a-col>
                  </a-row>
                  <!-- <a-row> -->
                  <!-- <a-col :span="6" v-if="HousesData.accendantId === uid">
                      <p>委托</p>
                      <p v-if="HousesData.isEntrust === 'N'" tyle="display: flex; margin-right: 3px">
                        暂无委托，<a-button type="link" @click="showuploadmoadl(7)">上传</a-button>
                      </p>
                      <p v-else>已上传委托,<a-button @click="viewEntrust" type="link">查看</a-button></p>
                    </a-col> -->

                  <!-- <a-col :span="6">
                      <p>钥匙</p>
                      <p v-if="HousesData.identityKey == 'N'" tyle="display: flex; margin-right: 3px">
                        暂无钥匙，<a-button type="link" @click="showuploadmoadl(6, 'add')">上传钥匙</a-button>
                      </p>
                      <p v-else>
                        {{ HousesData.keyTeamName }},{{ HousesData.keyUserName
                        }}<a-button type="link" @click="showuploadmoadl(6, 'edit')">交接钥匙</a-button>
                      </p>
                    </a-col> -->
                  <!-- </a-row> -->
                </div>

                <a-divider />
                <div class="house_intro_remark">
                  <div class="house_intro textarea_info">
                    <p class="title" >房源优势</p>
                    <p class="con" :title="HousesData.houseDescription ? HousesData.houseDescription : '未填写'">
                      <pre>{{ HousesData.houseDescription ? HousesData.houseDescription : '未填写' }}</pre>
                    </p>
                  </div>
                  <div class="house_remark textarea_info">
                    <p class="title" >备注</p>
                    <p class="con" :title="HousesData.otherInfo ? HousesData.otherInfo : '暂无备注'">
                      <pre>{{ HousesData.otherInfo ? HousesData.otherInfo : '暂无备注' }}</pre>
                    </p>
                  </div>
                </div>

                <a-divider />
                <div class="bot-detail">
                  <a-row>
                    <a-col :span="12">
                      <div style="display: flex; justify-content: space-between; width: 100%">
                        <p>动态</p>
                        <div class="" style="margin-top: 20px">
                          <span
                            class="iconfont icon-bianji1"
                            v-if="HousesData.accendantId === uid"
                            style="font-size: 14px; color: var(--ThemeColor)"
                          ></span>
                          <span
                            @click="followFn"
                            v-if="HousesData.accendantId === uid"
                            style="cursor: pointer"
                          >写跟进</span
                          >
                          <!-- v-hasPermi="['houses:followUpRecord:add']" -->

                          <span
                            @click="Recording()"
                            v-if="HousesData.accendantId === uid"
                            style="cursor: pointer"
                          >录面访</span
                          >
                        <!-- v-hasPermi="['houses:interviewRecord:add']" -->
                        </div>
                      </div>
                    </a-col>
                    <a-col :span="12">
                      <div style="display: flex; justify-content: space-between; width: 100%">
                        <p style="margin-left: 6px">相关人员</p>
                        <div style="margin-top: 20px">
                          <span
                            class="iconfont icon-bianji1"
                            v-hasPermi="['houses:relatedPersonnelInfo:edit']"
                            style="font-size: 14px; color: var(--ThemeColor)"
                          ></span>
                          <span
                            @click="showedit('编辑人员')"
                            v-hasPermi="['houses:relatedPersonnelInfo:edit']"
                            style="cursor: pointer"
                          >编辑人员</span
                          >
                        </div>
                      </div>
                    </a-col>
                  </a-row>
                  <div class="bot-detail-bot">
                    <div class="bot-detail-left">
                      <div class="bot-detail-left-center">
                        <ul>
                          <li
                            v-for="(item, index) in botList"
                            :key="item.id"
                            :class="{ show: curtId == index }"
                            @click="upStatus(index)"
                            style="cursor: pointer"
                          >
                            {{ item.title }}
                          </li>
                        </ul>
                        <div class="child-bot">
                          <a-spin :spinning="recordlistSpinning">
                            <no-data v-if="recordlist && recordlist.length === 0"></no-data>
                            <div class="row" v-else v-for="(item, index) in recordlist" :key="index">
                              <div class="col-one">
                                <div class="state">{{ item.recordType | filternumtoname }}</div>
                              </div>
                              <div class="col-two">
                                <p>{{ item.createByName }}</p>
                                <p v-if="item.recordType == 4" class="flex-warp">
                                  带<span
                                    @click="goTouristSourceDetails(item.requirementId)"
                                    style="color: var(--ThemeColor); cursor: pointer"
                                  >{{ item.takeLookNames }}</span
                                  >查看了该房源,带看反馈:{{ item.recordContent }}
                                </p>
                                <p v-else class="flex-warp">{{ item.recordContent }}</p>
                              </div>
                              <div class="col-three">
                                <p style="text-align: right">{{ item.createTime }}</p>
                                <p
                                  v-if="item.recordType == 1"
                                  class="time downLoad"
                                  @click="handledownload(item.accessoryFileList)"
                                >
                                  下载附件
                                </p>
                              </div>
                            </div>
                            <div v-if="recordlist && recordlist.length !== 0" style="margin-top: 15px; float: right">
                              <!--分页-->
                              <a-pagination :current="current" :total="recordpage.total" @change="onChange" />
                            </div>
                          </a-spin>
                        </div>
                      </div>
                    </div>
                    <div class="bot-detail-right">
                      <div class="right-center">
                        <a-row v-for="(item, index) in RelaInfotabledata" :key="index">
                          <a-col :span="3">
                            <div style="width: 40px; height: 40px">
                              <img
                                v-if="item.avatar"
                                :src="item.avatar"
                                alt=""
                                :title="item.relatedPersonnelName"
                                width="100%"
                                height="100%"
                              />
                              <img
                                v-else
                                src="@/assets/images/defaultHeader.svg"
                                alt=""
                                :title="item.relatedPersonnelName"
                                width="100%"
                                height="100%"
                              />
                            </div>
                          </a-col>
                          <a-col :span="15">
                            <p class="department">
                              {{ item.relatedDeptName ? item.relatedDeptName + ' · ' : ' · '
                              }}{{ item.relatedPersonnelName }}
                            </p>
                            <p class="editdept">
                              {{ item.relatedPersonnelType | filterDict(relatedPersonneTypeOpts) }}
                              <span style="font-size: 12px; line-height: 24px"> {{ item.createTime }} </span>
                            </p>
                          </a-col>
                          <div style="position: absolute; right: 0; top: 36px">
                            <div style="padding-left: 17px">
                              <a-button
                                @click="Editor(item, '编辑人员')"
                                type="primary"
                                shape="circle"
                                icon="edit"
                                v-show="editbtnshow"
                                style="color: #fff; background: var(--ThemeColor); border-color: var(--ThemeColor)"
                              >
                              </a-button>
                            </div>
                          </div>
                        </a-row>
                        <div style="margin-top: 15px">
                        <!--分页-->
                        <!-- <a-pagination
                            :current="RelaInfoPage.pageNum"
                            :total="RelaInfoPage.total"
                            @change="onChangerela"
                          /> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div></a-tab-pane>
            <a-tab-pane key="2" tab="成交历史">
              <a-table
                :rowKey="
                  (record, index) => {
                    return index
                  }
                "
                :columns="columns"
                :loading="tableLoading"
                :pagination="pagination"
                @change="handleChangeInTable"
                :data-source="transactionHistoryList"
                :customRow="getContractDetail"
              >
                <a slot="name" slot-scope="text">{{ text }}</a>
                <template slot="contractCode" slot-scope="contractCode">
                  <h1 style="color: var(--ThemeColor)">{{ contractCode }}</h1>
                </template>
              </a-table>
            </a-tab-pane>
          </a-tabs>
        </div>
      </aside>
    </div>
    <!--新增图片-->
    <a-modal v-model="EditImgShow" :title="optTitleSk" @ok="handleEditSkImg" width="800px">
      <investigation-cmp
        :type="optType"
        :fileList="HousesData.houseInfoImgVo"
        @submitSkImg="submitSkImgHandele"
      ></investigation-cmp>
    </a-modal>

    <!--下载图片弹出-->
    <download-sk-cmp
      v-if="showDownLoad"
      :edit-download-img-show="editDownloadImgShow"
      @closeModal="hideDownloadFile"
      :fileList="houseInfoImgVo"
      :rentSaleType="this.rentSaleType"
    ></download-sk-cmp>

    <!-- 认领弹窗 -->
    <ClaimTK
      :visible="visible"
      :resourceId="Number(houseId)"
      :isOpenReceiveAudit="HousesData.isOpenReceiveAudit"
      :rentSaleType="this.rentSaleType"
      @closeTK="closeTK"
    ></ClaimTK>
    <!-- 查看弹窗 -->
    <a-modal
      v-model="lookShow"
      title="查看"
      id="lookModel"
      :footer="null"
      :maskClosable="false"
      :keyboard="false"
      :closable="iscloseBtn"
    >
      <div class="look">
        <div class="owner">业主</div>
        <div class="msg">
          <div v-for="item in ownerMsgList" :key="item.id">
            <p>{{ item.lessorsName }}</p>
            <p>{{ item.lessorsPhone }}</p>
          </div>
        </div>
      </div>
      <div v-if="!iscloseBtn" class="look_goFollowUpBtn" @click="goFollowUpBtn">去跟进 ></div>
    </a-modal>
    <!-- 跟进 -->
    <FollowUp
      :isFollow="followShow"
      :rentSaleType="this.rentSaleType"
      @closeModal="closeModalFollowUp"
      resourceType="1"
    ></FollowUp>
    <!--录面访-->
    <a-modal v-model="recordShow" title="录面访" @ok="handleInterview">
      <a-form-model-item label="面访时间">
        <a-date-picker
          show-time
          type="date"
          placeholder="请选择面访时间"
          format="YYYY-MM-DD"
          v-model="interviewRecorddate.interviewTime"
          style="width: 100%"
        />
      </a-form-model-item>
      <a-textarea
        class="interview-textarea"
        placeholder="请输入面访内容"
        v-model="interviewRecorddate.interviewContent"
        style="width: 100%"
      />
      <h4>面访附件</h4>
      <div>
        <UploadBtn @input="uploadInterviewUrl" @ossId="interviewOssid" />
      <!-- <file-upload :value="interviewUrl" @input="uploadInterviewUrl" @ossId="interviewOssid">
          </file-upload>  -->
      </div>
    </a-modal>
    <!--上传钥匙弹出框-->
    <a-modal :visible="uploadmodal" @cancel="uploadmodal = false" :title="keyTitle" @ok="uploadK" :centered="true">
      <a-form-model-item label="收钥匙团队">
        <a-tree-select
          v-model="KeysList.collectKeyTeamId"
          style="width: 100%"
          :dropdown-style="{ maxHeight: '300px', overflow: 'auto' }"
          :tree-data="deptOptions"
          placeholder="请选择收钥匙团队"
          :replaceFields="replaceFields"
          tree-default-expand-all
          @change="handleChangeTreekeys"
        >
        </a-tree-select>
      </a-form-model-item>
      <a-form-model-item label="收钥匙人员">
        <a-select
          v-model="KeysList.collectKeyUserId"
          @dropdownVisibleChange="handleOptionkeys($event)"
          placeholder="请选择收钥匙人员"
          style="width: 100%"
        >
          <a-select-option v-for="item in userList" :key="item.userId" :value="item.userId">
            {{ item.nickName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="收钥匙日期">
        <a-date-picker
          v-model="KeysList.recordTime"
          show-time
          type="date"
          placeholder="请选择收钥匙日期"
          style="width: 100%"
        />
      </a-form-model-item>
    </a-modal>
    <!--上传委托-->
    <a-modal
      :visible="uploadEntrust"
      @cancel="uploadEntrust = false"
      wrapClassName="modalUploadEntrust"
      :title="entrustTitle"
      @ok="uploadTrust"
      :getContainer="() => $refs.housesDetail"
      :centered="true"
    >
      <a-form-model-item label="委托时间">
        <a-date-picker
          v-model="entrust.recordTime"
          valueFormat="YYYY-MM-DD hh:mm:ss"
          format="YYYY-MM-DD hh:mm:ss"
          show-time
          type="date"
          placeholder="请选择委托时间"
          style="width: 100%"
        />
      </a-form-model-item>
      <a-textarea
        v-model="entrust.recordContent"
        placeholder="请输入委托内容"
        :autoSize="true"
        style="width: 100%; height: 50px; border-radius: 10px"
      />
      <a-row style="margin-top: 15px">
        <a-col :span="12">
          <h4>委托书</h4>
          <div class="uploads">
            <upload-cmp
              :img-url="entrustAccessoryFile1 && entrustAccessoryFile1.fileName ? entrustAccessoryFile1.fileName : ''"
              type="image"
              @fileUrlFn="entrust1FileUrlFn"
            ></upload-cmp>
            <a-input v-show="1 === 2" v-model="entrust.entrustFileIds" placeholder="请输入" />
          </div>
        </a-col>
        <a-col :span="12">
          <h4>产权证</h4>
          <div class="uploads">
            <upload-cmp
              :img-url="entrustAccessoryFile2 && entrustAccessoryFile2.fileName ? entrustAccessoryFile2.fileName : ''"
              type="image"
              @fileUrlFn="entrust2FileUrlFn"
            ></upload-cmp>
            <a-input v-show="1 === 2" v-model="entrust.propertyCertificateIds" placeholder="请输入" />
          </div>
        </a-col>
      </a-row>
    </a-modal>
    <!--编辑人员弹窗-->
    <a-modal
      :visible="editorShow"
      @cancel="editorShow = false"
      :title="deitMaintainerTitle"
      @ok="editStaff"
      :centered="true"
    >
      <a-form-model-item label="人员团队名称">
        <a-tree-select
          v-model="fromStaff.keyTeam"
          style="width: 100%"
          :tree-data="deptOptions"
          placeholder="请选择人员团队名称"
          :replaceFields="replaceFields"
          tree-default-expand-all
          @change="handleChangeTreeedit"
        ></a-tree-select>
      </a-form-model-item>
      <a-form-model-item label="人员名称">
        <a-select
          v-model="fromStaff.ketemp"
          @dropdownVisibleChange="handleOptionedit($event)"
          placeholder="请选择人员名称"
          style="width: 100%"
        >
          <a-select-option v-for="item in userList" :key="item.userId" :value="item.userId">
            {{ item.nickName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
    </a-modal>
    <!-- 转维护人 -->
    <!--loading-->
    <div class="topcenter" v-show="loading">
      <LoadingModel></LoadingModel>
    </div>
    <div v-if="showSwiperImg" class="preview_cover" @click="closeSwiperImg">
      <img v-if="previewType==='img'" class="preview_img" title="点击图片任意位置退出预览" :src="swiperImgUrl" alt="preview"/>
      <video
        class="preview_video"
        title="点击视频任意位置退出预览"
        v-if="previewType==='video'"
        :src="swiperImgUrl"
        controls="controls">该内容不支持播放</video>
    </div>
  </div>
</template>

<script>
// 上传
// 引入图标
import './assets/font/iconfont.css'
import houseApi, { userSeeRecord } from '@/api/system/houses/house.js'
import storage from 'store'
import FollowUp from '@/components/modal/FollowUp.vue'
import ClaimTK from '@/components/modal/ClaimTK.vue'
import LoadingModel from '@/components/Loading'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import InvestigationCmp from '@/views/houses/details/detail/investigation'
import DownloadSkCmp from '@/views/houses/details/detail/download'
import UploadCmp from '@/components/UploadCmp/index'
import UploadBtn from '@/components/UploadBtn'
import { contractsInfoList } from '@/api/system/contract'
import { treeSelectMixin } from '@/mixin/treeSelect'

import { mapGetters } from 'vuex'

// import 'swiper/css/swiper.min.css' // 注意这里的引入
import 'swiper/css/swiper.css'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
var vm = null

const OSS_BASE_URL = process.env.VUE_APP_OSS_URL
function getBase64 (img, callback) {
  const reader = new FileReader()
  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}
// 表格数据
const columns = [
  {
    title: '合同',
    dataIndex: 'contractCode',
    key: '1',
    scopedSlots: {
      customRender: 'contractCode'
    }
  },
  {
    title: '品牌',
    dataIndex: 'shopName',
    key: '2'
  },
  {
    title: '成交时间',
    dataIndex: 'signDate',
    key: '4',
    ellipsis: true
  },
  {
    title: '成交价格',
    dataIndex: 'rentExpense',
    key: '5',
    ellipsis: true
  },
  {
    title: '房佣',
    dataIndex: 'lessorComm',
    key: '6',
    ellipsis: true
  },
  {
    title: '客佣',
    dataIndex: 'lesseeComm',
    key: '7',
    ellipsis: true
  }
]

export default {
  name: 'HousesDetails',
  components: {
    FollowUp,
    ClaimTK,
    LoadingModel,
    InvestigationCmp,
    DownloadSkCmp,
    UploadCmp,
    UploadBtn,
    Swiper,
    SwiperSlide
  },
  mixins: [treeSelectMixin],

  data () {
    return {
      showOtherInfo: false, // 是否显示其他信息
      iscloseBtn: false, // 查看框的关闭按钮
      rentSaleType: '1', // 出租
      newFollowUpMsg: {}, // 最新跟进信息
      swiperOptionThumbs: {
        loop: true, // 循环模式选项
        // spaceBetween: 0,
        spaceBetween: 10,
        slidesPerView: 4,
        centeredSlides: true, // 设置活动块居中
        slideToClickedSlide: true,
        navigation: {
          prevEl: '.swiper-thumbs-next',
          nextEl: '.swiper-thumbs-prev'
        },
        on: {
          slideChangeTransitionStart: function () {
            vm.$refs.swiperTop.$swiper.slideToLoop(this.realIndex, 1000, false)
          }
        }
      },
      swiperOptionTop: {
        loop: true, // 循环模式选项
        // autoplay: true, //自动循环
        slidesPerView: 1, // 设置slider容器能够同时显示的slides数量(carousel模式)。
        // spaceBetween: -100, // 在slide之间设置距离（单位px）。
        spaceBetween: 10,
        // centeredSlides: true, // 设置活动块居中
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev'
        // },
        on: {
          slideChangeTransitionStart: function () {
            if (vm.$refs.swiperThumbs.$swiper !== undefined) {
              console.log(vm.$refs.swiperThumbs.$swiper.slideToLoop(this.realIndex, 1000, false))
            }
          }
        }
      },
      // 成交历史表格数据
      transactionHistoryList: [],
      columns,
      tableLoading: false,
      // 分页参数
      pagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          // range[0] + '-' + range[1] +
          return ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      OSS_BASE_URL,
      isuser: true,
      isKeyuser: true,
      interviewUrl: '', // 面访url
      deitMaintainerTitle: '编辑人员', // 编辑人员 修改委托人的弹窗
      entrustTitle: '上传委托',
      keyTitle: '上传钥匙',
      recordlistSpinning: false,
      ownerMsgList: [], // 业主信息
      headers: {
        authorization: 'Bearer ' + storage.get(ACCESS_TOKEN)
      },
      shopTypeOpts: [],
      shopNatureOpts: [],
      operatingStatusOpts: [],
      industryCategoryOpts: [],
      industrySubclassOpts: [],
      weatherOpts: [],
      proppertyNatureOpts: [],
      relatedPersonneTypeOpts: [], // 相关人员类型 字典表类型：related_personne_type
      repastTypeOpts: [],
      dishTypeOpts: [],

      showClaim: false,

      optType: '1',
      optTitleSk: '新增实勘图',

      showDownLoad: false,

      param_identity: {
        id: undefined, //	房源ID		true
        identity: undefined, //	标识（1:五，2:独，3:优，4:钥匙）		true
        identityStr: undefined //	标识状态 字典表类型：sys_yes_no
      },

      investigationIdArr: [], // 实勘图ids
      buttonWidth: 70,
      // 分页
      current: 1,
      // 加载
      loading: false,
      // 认领弹窗
      visible: false,
      ModleVisible: false,
      // 上传钥匙弹出框
      uploadmodal: false,
      // 上传委托
      uploadEntrust: false,
      // 录面访
      recordShow: false,
      // 编辑人员
      editorShow: false,
      // 查看
      lookShow: false,
      // 编辑图片
      EditImgShow: false,
      // 下载图片
      editDownloadImgShow: false,
      // 跟进
      followShow: false,
      // 添加审核人
      Reviewer: false,
      // 全部
      allShow: false,
      hoall: true,
      // 跟进文本框
      followValue: '',
      // 认领
      confirmLoading: false,
      imageUrl: '',
      imageUrlAttorney: '',
      imageUrlCertificate: '',
      loadingAttorney: false,
      loadingCertificate: false,
      value: '',
      num: 0,
      num1: 0,
      // 轮播
      swiperOption: {
        // notNextTick: true,
        autoplay: true,
        speed: 3000,
        loop: true,
        slidesPerView: 3,
        watchSlidesVisibility: true, // 防止不可点击
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
        // spaceBetween: 10,
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev'
        // }
      },

      // swiperOptionThumbs: {
      //   spaceBetween: 10,
      //   centeredSlides: true,
      //   slidesPerView: 'auto',
      //   touchRatio: 0.2,
      //   slideToClickedSlide: true
      // },
      // currSwiperIdx: 0, // 当前的swiper下标

      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      personList: { title: '' },
      botList: [
        { id: 1, title: '全部', status: true },
        { id: 2, title: '跟进', status: false },
        { id: 3, title: '面访', status: false },
        { id: 4, title: '钥匙', status: false },
        { id: 5, title: '查看', status: false },
        { id: 6, title: '其他', status: false },
        { id: 7, title: '被带看', status: false },
        { id: 8, title: '意向', status: false }
      ],
      curtId: 0,
      IconStatus: {
        id: 1,
        identity: '1',
        identityStr: '1'
      },
      imgPrefix: process.env.VUE_APP_OSS_URL,
      // 轮播图图片
      AddImg: [
        { id: 1, imgSrc: require('../detail/assets/img/detail-img.png') },
        { id: 1, imgSrc: require('../detail/assets/img/detail-img.png') }
      ],

      // 新增面访记录
      interList: {
        accessoryIds: '',
        houseId: '1',
        recordContent: '1',
        recordTime: '',
        recordType: '1'
      },
      // 上传委托
      entrust: {
        accessoryIds: '',
        houseId: this.houseId,
        recordContent: '',
        recordTime: '',
        recordType: '6',
        propertyCertificateIds: '', // '产权url'
        entrustFileIds: '' // 委托
      },
      entrustOpt: 1, // 1新增 2修改

      entrustAccessoryFile1: {
        createBy: '',
        createTime: '',
        fileName: '',
        fileSuffix: '',
        originalName: '',
        ossId: undefined,
        service: 'huawei',
        url: ''
      },
      entrustAccessoryFile2: {
        createBy: '',
        createTime: '',
        fileName: '',
        fileSuffix: '',
        originalName: '',
        ossId: undefined,
        service: 'huawei',
        url: ''
      },

      // 上传钥匙
      KeysList: {
        collectKeyTeamId: '', // 收钥匙团队
        collectKeyUserId: '', // 收钥匙人员
        houseId: this.houseId, // 房源ID
        recordTime: '', // 收钥匙时间
        recordType: '5' // 记录类型（1:面访，2:跟进，3:查看 4:被带看 5：钥匙 6：其他） 字典表类型：record_type
      },
      // 新增认领记录
      addRecord: {
        auditIds: '1',
        receiveRemark: '11',
        receiveType: '1',
        resourceId: 1
      },
      // 跟进记录
      followUpRecord: {
        followUpContent: '房源新',
        resourceId: 1,
        resourceType: '1'
      },
      // 房源详细信息
      HousesData: {},
      // 商铺类型
      shopType: [],
      // 商铺性质
      shopNature: [],
      // 上传钥匙-from
      kyfrom: {
        keyTeam: '',
        ketemp: ''
      },
      // 收钥匙团队
      teamList: [],
      // 收钥匙人员
      empList: [],
      // 编辑人员团队
      staffList: [],
      // 编辑人员名称
      editStaffList: [],
      // 上传委托图片
      // loading: false,
      // imageUrl: '',
      // 认领人员
      ryfrom: {
        Claimketemp: ''
      },
      // 编辑相关人员
      fromStaff: {
        keyTeam: '',
        ketemp: ''
      },
      // 写跟进
      remindfromlist: [
        {
          GJdepartment: '',
          GJrenyuan: '',
          GJdate: '',
          followValue: ''
        }
      ],
      // 认领人员下拉
      ClaimempList: [],
      tabindex: 0,
      recordlist: [],
      recordpage: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        current: 1
      },
      index_a: 0, // 分页用全局分页参数
      editbtnshow: false, // 编辑按钮控制显示
      RelaInfoPage: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      }, // 相关人员查询分页参数
      RelaInfotabledata: [], // 相关人员数据
      // 录面访 数据
      interviewRecorddate: {
        accessoryIds: '', // 附件id
        interviewContent: '',
        interviewTime: '',
        resourceId: 0,
        resourceType: 1
      },
      edit_id: '', // 当前编辑人员id
      RLSHlist: [], // 认领人员
      FYLXlist: [], // 房源类型
      lookShowdata: {
        username: '周先生',
        phone: '13599999999',
        imgurl: '' // 头像
      },
      moreModalvb: false,
      houseId: '', // 房源id
      historyList: [], // 成交历史
      cha: 0,
      addImgData: {
        houseId: undefined, //	id不能为空		true
        identity: undefined, //	请求类型标识（1：新增实勘:2：编辑图片）		true
        investigationImgs: {
          1: '',
          2: '',
          3: '',
          4: '',
          5: ''
        } // 实勘图片IDs		true
      },
      curBigImg: '',
      imgOssIdObj: {}, // 实勘图ossId对象
      skImgList: [], // 实勘图片集(用于轮播展示)
      skEditImgList: [], // 实勘图片集(用于编辑实盘展示)
      houseInfoImgVo: {}, // 实勘图对象（下载）
      uid: undefined,
      position: undefined, // 0.普通员工，1.门店，2.团队或小组（string）
      industryCategoryJsonName: [], // 行业大类名称
      industrySubclassJsonName: [], // 行业小类名称
      industryCategoryJsonNameStr: '', // 行业大类名称
      industrySubclassJsonNameStr: '', // 行业小类名称
      showSwiperImg: false,
      swiperImgUrl: '',
      previewType: 'img'// 预览类型

    }
  },

  mounted () {
    /* var mySwiper = new Swiper('.swiper-container', {
			slidesPerView : 3,
      centeredSlides : true,
		}) */
  },
  created () {
    this.goFollowUpBtn() // 防止查看后刷新

    vm = this
    this.uid = this.$getters.userInfo.userId
    this.position = this.$getters.userInfo.position
    this.getDicts('shop_type').then((response) => {
      this.shopTypeOpts = response.data
    })

    this.getDicts('shop_nature').then((response) => {
      this.shopNatureOpts = response.data
    })
    this.getDicts('operating_status').then((response) => {
      this.operatingStatusOpts = response.data
    })
    this.getDicts('industry_categor').then((response) => {
      this.industryCategoryOpts = response.data
    })
    this.getDicts('industry_subclass').then((response) => {
      this.industrySubclassOpts = response.data
    })
    this.getDicts('sys_yes_no').then((response) => {
      this.weatherOpts = response.data
    })
    this.getDicts('property_nature').then((response) => {
      this.proppertyNatureOpts = response.data
    })
    // 相关人员类型 字典表类型：related_personne_type
    this.getDicts('related_personne_type').then((response) => {
      this.relatedPersonneTypeOpts = response.data
    })
    this.getDicts('repast_type').then((response) => {
      this.repastTypeOpts = response.data
    })

    // 盘别
    this.getDicts('dish_type').then((response) => {
      this.dishTypeOpts = response.data
    })

    this.houseId = this.$route.query.id
    this.getHouseDetails()
    this.upStatus(0)
    this.getRelaInfoListFn() // 相关人员查询
    this.getFollowUp() // 第一条跟进信息
  },

  methods: {
    previewSwiperImg (url, type) {
      this.showSwiperImg = true
      this.swiperImgUrl = url
      this.previewType = type// 预览类型
    },
    closeSwiperImg () {
      this.showSwiperImg = false
      this.swiperImgUrl = ''
    },
    showHideOtherInfo () {
      this.showOtherInfo = !(this.showOtherInfo)
    },
    // 查看弹窗-去跟进弹窗
    goFollowUpBtn () {
      userSeeRecord().then((res) => {
        if (res.code === 200) {
          this.lookShow = false
          this.$store.commit('SET_IS_FOLLOWUP_OBJ', res.data)
        }
      })
    },
    // 一键同步
    getSynchronization () {
      const parmars = {
        id: this.houseId,
        rentSaleType: this.rentSaleType,
        channelResource: '1'
      }
      houseApi.synchronization(parmars).then((res) => {
        if (res.code === 200) {
          this.$message.success('同步成功')
        }
      })
    },
    // 点击table切换
    getTabs (index) {
      // 请求成交历史历史
      if (index === '2') {
        this.getTransactionHistoryList()
      }
    },
    // 下载附件
    handledownload (list) {
      const url = list[0].url
      var a = document.createElement('a') // 创建一个a节点插入的document
      var event = new MouseEvent('click') // 模拟鼠标click点击事件
      a.download = 'file' // 设置a节点的download属性值
      a.href = url // 将图片的src赋值给a节点的href
      a.dispatchEvent(event)
    },
    // 成交历史
    getTransactionHistoryList () {
      const params = {
        houseId: this.houseId,
        rentSaleType: this.rentSaleType,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize
      }
      this.tableLoading = true
      contractsInfoList(params).then(({ code, data }) => {
        this.tableLoading = false
        if (code === 200) {
          this.transactionHistoryList = data.records
          this.pagination.total = data.total
        }
      })
    },
    // 历史成交分页
    handleChangeInTable (pagination, filters, sorter) {
      // 分页、排序、筛选变化时触发
      this.pagination = pagination
      this.getTransactionHistoryList()
    },
    //
    getContractDetail: function (record, index) {
      return {
        on: {
          click: () => {
            this.$router.push({
              path: '/contract/details',
              query: { id: record.id }
            })
          }
        }
      }
    },

    contractList () {
      const params_history = {}
      houseApi.contractList(params_history).then((res) => {
        if (res.code === 200) {
          this.historyList = res.data
        }
      })
    },
    // 获取相关人员列表
    getRelaInfoListFn () {
      const params = {
        pageNum: this.RelaInfoPage.pageNum,
        pageSize: this.RelaInfoPage.pageSize,
        resourceId: this.houseId,
        resourceType: 1,
        rentSaleType: this.rentSaleType
      }
      houseApi
        .getRelaInfoList({
          ...params
        })
        .then((res) => {
          if (res.code === 200) {
            this.RelaInfoPage.total = res.data.total
            this.RelaInfotabledata = res.data.records
          }
        })
    },
    // 认领按钮
    handleClaim () {
      this.visible = true
    },
    closeTK () {
      this.visible = false
      this.getHouseDetails()
    },
    // 编辑图片
    addImg () {
      this.EditImgShow = true
      this.optType = '1'
      this.optTitleSk = '新增实勘图'
    },
    EditImg () {
      this.EditImgShow = true
      this.optType = '2'
      this.optTitleSk = '编辑实勘图'
    },
    // 查看
    handleLook () {
      // 通过id查询任务信息
      const parmars = {
        id: this.houseId,
        rentSaleType: this.rentSaleType
      }
      houseApi.houseOwner(parmars).then((res) => {
        if (res.code === 200) {
          this.ownerMsgList = res.data
          this.upStatus(4)

          userSeeRecord().then((res) => {
            if (res.code === 200) {
              if (res.data.isFollowUp === 'Y') {
                this.iscloseBtn = true
              } else {
                this.iscloseBtn = false
              }
              this.lookShow = true
            }
          })
        }
      })
    },
    // 写跟进
    followFn () {
      this.followShow = true
      this.getYSteamList()
    },
    closeModalFollowUp () {
      this.followShow = false
      this.upStatus(1)
      this.getFollowUp() // 第一条跟进信息
    },
    // 跟进内容添加行

    addremindfromlist () {
      const obj = {
        GJdepartment: '',
        GJrenyuan: '',
        GJdate: '',
        followValue: ''
      }
      this.remindfromlist.push(obj)
    },
    // 认领-审核人
    addPicture () {
      this.Reviewer = true
    },
    // 认领审核人提交
    Reviewerfun () {
      const nameindex = this.ClaimempList.findIndex((item) => {
        return item.userId == this.ryfrom.Claimketemp
      })
      const obj = {
        imgurl: '',
        // SHname: this.ClaimempList[nameindex].userName
        SHname: this.ClaimempList[nameindex].nickName
      }
      this.RLSHlist.push(obj)
      this.Reviewer = false
    },

    // 录面访
    Recording () {
      this.recordShow = true

      // 获取录面访的房源来源类型
      this.getDicts('shop_type').then((res) => {
        if (res.code === 200) {
          this.FYLXlist = res.data
        }
      })
    },
    showedit () {
      this.editbtnshow = !this.editbtnshow
    },
    // 编辑
    edit () {
      // 帧数据后 这里应该可以获取到房源id 房源id通过路由传过去
      this.$router.push({ path: '/houses/add', query: { tpfunname: '房源/编辑商铺', id: this.houseId } })
      // this.$router.push('/houses/add')
    },

    // 跟进提交
    handleFollow () {},
    // 录制面访提交
    handleInterview () {
      if (!this.interviewRecorddate.interviewTime) {
        this.$message.warning('请输入面访时间')
        return
      }
      if (!this.interviewRecorddate.interviewContent) {
        this.$message.warning('请输入面访内容')
        return
      }
      if (!this.interviewRecorddate.accessoryIds) {
        this.$message.warning('请上传面访附件')
        return
      }
      const sdate = new Date(this.interviewRecorddate.interviewTime)
      const aa = sdate.getFullYear() + '-' + (sdate.getMonth() + 1) + '-' + sdate.getDate()
      this.interviewRecorddate.interviewTime = aa
      this.interviewRecorddate.resourceId = this.houseId
      this.interviewRecorddate.rentSaleType = this.rentSaleType
      houseApi.interviewRecord({ ...this.interviewRecorddate }).then((res) => {
        if (res.code === 200) {
          this.$message.success('录入面访成功')
          this.upStatus(0)
          this.recordShow = false
        }
      })
    },

    // 上传

    // 选择时间
    onChangeData (date, dateString) {},
    //
    confirm () {},
    //
    beforeUpload () {},
    // 轮播按钮
    leftBtn () {
      const img = document.getElementById('imgbox')
      this.num -= 200
      img.style.marginLeft = this.num + 'px'
    },
    rightBtn () {
      const img = document.getElementById('imgbox2')
      this.num1 -= 200
      img.style.marginRight = this.num + 'px'
    },
    // 获取房源的详细信息
    getHouseDetails () {
      houseApi.houseDetails(this.houseId).then((res) => {
        if (res.code === 200) {
          console.log(res.data, '房源你想去')
          this.HousesData = res.data
          // 行业大类名称
          const industryCategoryJsonName = this.HousesData.industryCategoryJsonName
          this.industryCategoryJsonName = industryCategoryJsonName ? JSON.parse(industryCategoryJsonName) : []
          this.industryCategoryJsonNameStr = industryCategoryJsonName ? industryCategoryJsonName.replace(/\[/g, '').replace(/\]/g, '').replace(/\"/g, '') : ''// 行业大类名称

          // 行业小类名称
          const industrySubclassJsonName = this.HousesData.industrySubclassJsonName
          this.industrySubclassJsonName = industrySubclassJsonName ? JSON.parse(industrySubclassJsonName) : []
          this.industrySubclassJsonNameStr = industrySubclassJsonName ? industrySubclassJsonName.replace(/\[/g, '').replace(/\]/g, '').replace(/\"/g, '') : ''

          const imgVo = this.HousesData.houseInfoImgVo
          this.houseInfoImgVo = imgVo
          this.rebuildSkImgList(imgVo)
          this.initSkParams()
          this.RelaInfoPage.pageNum = 1
          this.getRelaInfoListFn()

          // 非私盘可认领 （1私盘 2单店 3 公司）
          this.showClaim = this.HousesData.dishType !== '1'
        }
      })
    },
    rebuildSkImgList (imgVo) {
      const interiorList_ = imgVo.interiorList
      const planeList_ = imgVo.planeList
      const rimList_ = imgVo.rimList
      const thisShopList_ = imgVo.thisShopList
      const videoList_ = imgVo.videoList
      let skImgList_ = []
      skImgList_ = this.getSkList(videoList_, skImgList_)
      skImgList_ = this.getSkList(interiorList_, skImgList_)
      skImgList_ = this.getSkList(planeList_, skImgList_)
      skImgList_ = this.getSkList(rimList_, skImgList_)
      skImgList_ = this.getSkList(thisShopList_, skImgList_)

      this.skImgList = skImgList_
    },
    getSkList (list, resList) {
      if (list != null && list.length > 0) {
        for (const item of list) {
          resList.push(item)
        }
      }
      return resList
    },

    onChangerela (current) {
      this.RelaInfoPage.pageNum = current
      this.getRelaInfoListFn()
    },
    onChange (current) {
      this.current = current
      this.recordpage.pageNum = current
      this.upStatus(this.index_a)
    },
    // 查询房源动态记录列表
    upStatus (index) {
      this.recordlistSpinning = true
      this.recordlist = []
      this.index_a = index
      this.recordpage.current = 1
      const params = {
        pageNum: this.recordpage.pageNum,
        pageSize: this.recordpage.pageSize
      }

      if (this.botList[index].id === 1) {
        // 全部
      }
      if (this.botList[index].id === 2) {
        // 跟进
        params.recordType = 2
      }
      if (this.botList[index].id === 3) {
        // 面访
        params.recordType = 1
      }
      if (this.botList[index].id === 4) {
        params.recordType = 5
        // 钥匙
      }
      if (this.botList[index].id === 5) {
        params.recordType = 3
        // 查看
      }
      if (this.botList[index].id === 6) {
        params.recordType = 6
        // 其他
      }
      if (this.botList[index].id === 7) {
        params.recordType = 4
        // 其他
      }
      if (this.botList[index].id === 8) {
        params.recordType = 8
        // 意向
      }
      params.houseId = this.houseId
      params.rentSaleType = this.rentSaleType
      this.curtId = index
      houseApi
        .getInterview({
          ...params
        })
        .then((res) => {
          this.recordlistSpinning = false
          if (res.code === 200) {
            this.recordlist = res.data.records
            this.recordpage.total = res.data.total
            // this.recordpage.current=res.data.current
            this.loading = false
          }
        })
    },
    detailAll (val) {
      this.hoall = val
      // if(val==2){

      // }
    },
    // 修改标识状态
    du () {
      houseApi
        .editHouseIdentity({
          ...this.IconStatus
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('状态修改成功')
          }
        })
    },
    changeStatus (item) {
      houseApi
        .editHouseInfoStatus({
          ...item
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('修改成功')
          }
        })
    },

    // 新增面访记录
    addInter () {
      houseApi
        .addInterview({
          ...this.interList
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('新增面访成功')
          }
        })
    },

    handleChange (info) {
      if (info.file.status === 'uploading') {
        this.loadingAttorney = true
        return
      }
      if (info.file.status === 'done') {
        // Get this url from response in real world.
        const { code, data } = info.fileList[0].response
        if (code === 200) {
          this.interviewRecorddate.accessoryIds = data.id
        }
        // getBase64(info.file.originFileObj, imageUrl => {
        //   this.imageUrlAttorney = imageUrl
        //   this.loadingAttorney = false
        // })
      }
    },
    handleChangeAttorney (info) {
      if (info.file.status === 'uploading') {
        this.loadingAttorney = true
        return
      }
      if (info.file.status === 'done') {
        // Get this url from response in real world.
        const { code, data } = info.fileList[0].response
        if (code === 200) {
          this.entrust.entrustFileIds = data.id
        }
        getBase64(info.file.originFileObj, (imageUrl) => {
          this.imageUrlAttorney = imageUrl
          this.loadingAttorney = false
        })
      }
    },
    handleChangeCertificate (info) {
      if (info.file.status === 'uploading') {
        this.loadingCertificate = true
        return
      }
      if (info.file.status === 'done') {
        // Get this url from response in real world.
        const { code, data } = info.fileList[0].response
        if (code === 200) {
          this.entrust.entrustFileIds = data.id
        }
        getBase64(info.file.originFileObj, (imageUrl) => {
          this.imageUrlCertificate = imageUrl
          this.loadingCertificate = false
        })
      }
    },
    beforeUpload (file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
      if (!isJpgOrPng) {
        this.$message.error('You can only upload JPG file!')
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('Image must smaller than 2MB!')
      }
      return isJpgOrPng && isLt2M
    },

    // 编辑人员
    Editor (item, e) {
      this.editorShow = true
      this.getEditTeam()
      this.getEditSemp()
      if (e === '编辑人员') {
        this.edit_id = item.id
        // 团队名称id
        this.deitMaintainerTitle = '编辑人员'
        this.fromStaff.keyTeam = item.relatedDeptId
        this.fromStaff.ketemp = item.relatedPersonnelId
        this.isuser = false
        this.getUserListItem()
      } else {
        this.deitMaintainerTitle = '转维护人'
        this.isuser = true
      }
    },
    // 删除人员
    Delete (index) {
      this.RelaInfotabledata.splice(index, 1)
    },
    // 上传委托
    uploadTrust () {
      if (!this.entrust.recordTime) {
        this.$message.error('请选择委托时间')
        return
      }
      if (!this.entrust.recordContent) {
        this.$message.error('请输入委托内容')
        return
      }
      if (!this.entrust.entrustFileIds) {
        this.$message.error('请上传委托书')
        return
      }
      this.entrust.houseId = this.houseId
      this.entrust.rentSaleType = this.rentSaleType
      this.entrust.recordType = '6' // 记录类型（1:面访，2:跟进，3:查看 4:被带看 5：钥匙 6：其他） 字典表类型：record_type

      if (this.entrustOpt === 1) {
        houseApi
          .uploadEntrust({
            ...this.entrust
          })
          .then((res) => {
            if (res.code === 200) {
              this.$message.success('上传委托成功')
              this.uploadEntrust = false
              this.initEntrustData()
              this.getHouseDetails()
              this.upStatus(0)
            }
          })
      } else {
        // 修改委托
        houseApi
          .editEntrust({
            ...this.entrust
          })
          .then((res) => {
            if (res.code === 200) {
              this.$message.success('修改委托成功')
              this.uploadEntrust = false
              this.initEntrustData()
              this.getHouseDetails()
            }
          })
      }
    },
    // 弹出上传钥匙弹出框
    showuploadmoadl (index, opt) {
      if (index === 6) {
        if (index === 6 && opt === 'edit') {
          this.keyTitle = '交接钥匙'
        } else {
          this.keyTitle = '上传钥匙'
        }
        this.uploadmodal = true
        this.getYSteamList()

        if (opt === 'add') {
          // 新增
        } else {
          // 编辑
          // 获取当前钥匙信息
        }
      }
      if (index === 7) {
        this.uploadEntrust = true
      }
    },
    // 获取收钥匙团队
    getYSteamList () {
      houseApi.getDeptList().then((res) => {
        if (res.code === 200) {
          this.teamList = res.data
        }
      })
    },
    // 点击收钥匙团队后
    getKeyUserList (deptId) {
      if (deptId) {
        this.isKeyuser = false
        this.KeysList.collectKeyUserId = ''
      } else {
        this.isKeyuser = true
      }
      houseApi.getUserList({ deptId }).then((res) => {
        if (res.code === 200) {
          this.empList = res.rows
        }
      })
    },
    // 选择编辑人员或者上传委托人员选择后
    getDepUserList (deptId) {
      if (deptId) {
        this.isuser = false
        this.fromStaff.ketemp = ''
      } else {
        this.isuser = true
      }
      this.getEditSemp(deptId)
    },

    // 上传钥匙
    uploadK (item) {
      if (!this.KeysList.collectKeyTeamId) {
        this.$message.error('请选择团队')
        return
      }
      if (!this.KeysList.collectKeyUserId) {
        this.$message.error('请选择人员')
        return
      }
      if (!this.KeysList.recordTime) {
        this.$message.error('请选择时间')
        return
      }
      this.KeysList.houseId = this.houseId // 房源ID
      this.KeysList.recordType = '5' // 记录类型（1:面访，2:跟进，3:查看 4:被带看 5：钥匙 6：其他） 字典表类型：record_type
      this.KeysList.rentSaleType = this.rentSaleType
      houseApi
        .uploadKeysMethod({
          ...this.KeysList
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('上传成功')
            this.uploadmodal = false
            this.KeysList.collectKeyTeamId = ''
            this.KeysList.collectKeyUserId = ''
            this.KeysList.recordTime = ''
            this.getHouseDetails()
            this.upStatus(0)
          }
        })
    },
    // 获取编辑人员团队
    getEditTeam () {
      houseApi.getDeptList().then((res) => {
        if (res.code === 200) {
          this.staffList = res.data
        }
      })
    },
    // 获取编辑人员名称
    getEditSemp (deptId) {
      houseApi.getUserList({ deptId }).then((res) => {
        if (res.code === 200) {
          this.editStaffList = res.rows
        }
      })
    },
    // 获取认领人员
    getRL () {
      houseApi.getUserList().then((res) => {
        if (res.code === 200) {
          this.ClaimempList = res.rows
        }
      })
    },
    // 相关人员编辑 // 转维护人
    editStaff () {
      if (this.deitMaintainerTitle === '编辑人员') {
        const indexTeam = this.staffList.findIndex((item) => {
          return item.deptId === this.fromStaff.keyTeam
        })
        const indexry = this.editStaffList.findIndex((item) => {
          return item.userId === this.fromStaff.ketemp
        })

        const params = {
          id: this.edit_id,
          relatedDeptId: this.fromStaff.keyTeam,
          relatedDeptName: this.staffList[indexTeam].deptName,
          relatedPersonnelId: this.fromStaff.ketemp,
          relatedPersonnelName: this.editStaffList[indexry].nickName,
          rentSaleType: this.rentSaleType
        }
        houseApi.relatedPersonnelInfoEdit({ ...params }).then((res) => {
          if (res.code === 200) {
            this.getRelaInfoListFn()
            this.$message.success('编辑人员成功')
            this.editorShow = false
            this.getHouseDetails()
          }
        })
      } else {
        // 转维护人人
        const parmars = {}
        parmars.id = this.houseId
        parmars.rentSaleType = this.rentSaleType
        parmars.deptId = this.fromStaff.keyTeam
        parmars.accendantId = this.fromStaff.ketemp
        houseApi.editMaintainer(parmars).then((res) => {
          if (res.code === 200) {
            this.getRelaInfoListFn()
            this.$message.success('转维护人成功')
            this.editorShow = false
            this.getHouseDetails()
          }
        })
      }
    },
    // 新增认领记录
    addReceiveRecord () {
      houseApi
        .addreceiveRecord({
          ...this.addRecord
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('新增成功')
            this.getHouseDetails()
          }
        })
    },
    // 跟进记录
    followUpRecordC () {
      houseApi
        .followUpRecord({
          ...this.followUpRecord
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('新增成功')
            this.getHouseDetails()
          }
        })
    },
    goList () {
      this.$router.push('/house')
    },
    editIdentityHandle (type, val) {
      // editIdentityHandle('du',HousesData.identityAlone)
      val = val === 'Y' ? 'N' : 'Y'
      this.loading = true

      this.param_identity = {
        id: this.houseId, //	房源ID		true
        identity: type, //	标识（1:五，2:独，3:优，4:钥匙）		true
        identityStr: val //	标识状态 字典表类型：sys_yes_no
      }
      const type_ = parseInt(type)
      houseApi.editIdentity(this.param_identity).then((res) => {
        if (res.code === 200) {
          this.loading = false
          if (type_ === 1) {
            this.HousesData.identityFive = val
          } else if (type_ === 2) {
            this.HousesData.identityAlone = val
          } else if (type_ === 3) {
            this.HousesData.identityExcellent = val
          } else if (type_ === 4) {
            this.HousesData.identityKey = val
          }
          this.$message.success('操作成功')
          this.getHouseDetails()
          //  this.$forceUpdate()
        } else {
          this.$message.error('操作失败')
          this.loading = false
        }
      })
    },
    // 实勘图处理
    handleEditSkImg () {
      //  this.initSkParams();
      this.addImgData.identity = this.optType //	请求类型标识（1：新增实勘:2：编辑图片）		true
      houseApi
        .investigation({
          ...this.addImgData
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('操作成功')
            this.EditImgShow = false
            this.initSkParams()
            this.getHouseDetails()
            this.getRelaInfoListFn()
          }
        })
    },
    initSkParams () {
      this.addImgData = {
        houseId: this.houseId, //	id不能为空
        identity: this.optType, //	请求类型标识（1：新增实勘:2：编辑图片）		true
        investigationImgs: {
          1: '',
          2: '',
          3: '',
          4: '',
          5: ''
        } // 实勘图片IDs		true
      }
      const imgVo = this.HousesData.houseInfoImgVo
      const interiorList_ = imgVo.interiorList
      const planeList_ = imgVo.planeList
      const rimList_ = imgVo.rimList
      const thisShopList_ = imgVo.thisShopList
      const videoList_ = imgVo.videoList

      // 1视频 2本铺 3内部 4平面 5周边
      this.addImgData.investigationImgs = {
        1: this.getListOssId(videoList_),
        2: this.getListOssId(thisShopList_),
        3: this.getListOssId(interiorList_),
        4: this.getListOssId(planeList_),
        5: this.getListOssId(rimList_)
      }
    },
    getListOssId (list) {
      let ossId = ''
      const ossIdArr = []
      if (list != null && list.length > 0) {
        for (const item of list) {
          ossIdArr.push(item.ossId)
        }
        ossId = ossIdArr.join(',')
      }
      return ossId
    },
    submitSkImgHandele (obj) {
      this.imgOssIdObj = obj

      this.addImgData.houseId = this.houseId
      this.addImgData.identity = this.optType
      this.addImgData.investigationImgs = obj
    },
    // 下载图片显示页面
    showDownloadFile () {
      this.editDownloadImgShow = true
      this.houseInfoImgVo = this.HousesData.houseInfoImgVo
      this.showDownLoad = true
    },
    hideDownloadFile () {
      this.editDownloadImgShow = false
    },
    // 下载实勘
    downloadFile () {
      this.loading = true
      const idArr = this.getDownloadAllOssId(this.addImgData.investigationImgs)
      for (const ossId_ of idArr) {
        const ossIdInt = parseInt(ossId_)
        houseApi.downloadOssId_house(ossIdInt).then((res) => {
          if (res.code === 200) {
            this.$message.success('下载成功')
          }
        })
      }
      this.loading = false
    },
    getDownloadAllOssId (obj) {
      let idArr = []
      let idStr = ''
      for (const k in obj) {
        if (obj[k] != null && obj[k] !== '' && typeof obj[k] !== 'undefined') {
          idStr += obj[k].split(',') + ','
        }
      }
      if (idStr != null && idStr.length > 1) {
        idStr = idStr.substring(0, idStr.length - 1)
      }
      idArr = idStr.split(',')
      idArr = idArr.map(Number)
      return idArr
    },

    // 查看委托
    viewEntrust () {
      this.entrustTitle = '查看委托'
      this.entrustOpt = 2
      this.loading = false
      this.uploadEntrust = true
      this.entrust.houseId = this.houseId
      this.entrust.recordType = '6' // 记录类型（1:面访，2:跟进，3:查看 4:被带看 5：钥匙 6：其他） 字典表类型：record_type
      const parmars = {
        houseId: this.houseId,
        rentSaleType: this.rentSaleType
      }
      houseApi.queryEntrust(parmars).then((res) => {
        if (res.code === 200) {
          this.loading = true
          const data = res.data
          this.entrust = data
          this.entrust.recordTime = data.createTime
          console.log(data.entrustFileList[0])
          const entrustFileList = data.entrustFileList
          const propertyCertificateList = data.propertyCertificateList

          this.entrustAccessoryFile1 = entrustFileList ? entrustFileList[0] : { createBy: '', createTime: '', fileName: '', fileSuffix: '', originalName: '', ossId: undefined, service: 'huawei', url: '' }
          this.entrustAccessoryFile2 = propertyCertificateList ? propertyCertificateList[0] : {
            createBy: '',
            createTime: '',
            fileName: '',
            fileSuffix: '',
            originalName: '',
            ossId: undefined,
            service: 'huawei',
            url: ''
          }

          this.entrust.entrustFileIds = this.entrustAccessoryFile1.ossId
          this.entrust.propertyCertificateIds = this.entrustAccessoryFile2.ossId
        } else {
          this.loading = true
        }
      })
    },

    initEntrustData () {
      this.entrust = {
        accessoryIds: '',
        houseId: this.houseId,
        recordContent: '',
        recordTime: '',
        recordType: '6',
        propertyCertificateIds: '', // '产权url'
        entrustFileIds: '' // 委托
      }
      this.entrustAccessoryFile1 = {
        createBy: '',
        createTime: '',
        fileName: '',
        fileSuffix: '',
        originalName: '',
        ossId: undefined,
        service: 'huawei',
        url: ''
      }
      this.entrustAccessoryFile2 = {
        createBy: '',
        createTime: '',
        fileName: '',
        fileSuffix: '',
        originalName: '',
        ossId: undefined,
        service: 'huawei',
        url: ''
      }
    },

    entrust1FileUrlFn (file) {
      this.entrust.entrustFileIds = file.ossId + ''
      this.entrustAccessoryFile1 = file
    },
    entrust2FileUrlFn (file) {
      this.entrust.propertyCertificateIds = file.ossId + ''
      this.entrustAccessoryFile2 = file
    },
    // 修改房源状态
    getEditHouseInfoStatus (lastStatus) {
      const parmars = {}
      parmars.lastStatus = lastStatus
      parmars.resourceId = this.houseId
      parmars.rentSaleType = this.rentSaleType
      parmars.resourceType = 1
      houseApi.editHouseInfoStatus(parmars).then((res) => {
        if (res.code === 200) {
          this.upStatus(0)
          this.getHouseDetails()
          if (lastStatus === 1) {
            // this.$message.success('转为有效成功')
            this.$message.success('上架成功')
            return
          }
          if (lastStatus === 3) {
            this.$message.success('房源设置为自行成交成功')
            return
          }
          if (lastStatus === 4) {
            this.$message.success('房源设置为无效成功')
            return
          }
          if (lastStatus === 5) {
            this.$message.success('房源设置为无效成功')
          }
          if (lastStatus === 6) {
            // this.$message.success('转为待完善成功')
             this.$message.success('下架成功')
          }
        }
      })
    },
    // 录面访图片
    uploadInterviewUrl (e) {
      this.interviewUrl = e
    },
    interviewOssid (id) {
      this.interviewRecorddate.accessoryIds = id
    },
    // 前往客源详情
    goTouristSourceDetails (id) {
      this.$router.push({
        path: '/tourist/details',
        query: { id }
      })
    },
    // 获取最新一条跟进记录
    getFollowUp () {
      const params = {
        pageNum: 1,
        pageSize: 1,
        recordType: 2,
        rentSaleType: this.rentSaleType,
        houseId: this.houseId
      }
      houseApi
        .getInterview({
          ...params
        })
        .then((res) => {
          if (res.code === 200) {
            if (res.data.records[0] && res.data.records[0].length !== 0) {
              this.newFollowUpMsg = res.data.records[0]
            }
          }
        })
    }
  },
  computed: {
    ...mapGetters(['isfollowUpObj'])
  },
  watch: {
    currSwiperIdx () {
      this.curBigImg = OSS_BASE_URL + this.skImgList[this.currSwiperIdx].fileName
    },
    isfollowUpObj: {
      handler (valObj) {
        if (valObj && valObj.isFollowUp === 'N') {
          console.log(valObj, 'watch**********')
          this.followFn()
        }
      },
      deep: true,
      immediate: true
    }
  },

  filters: {
    fiflterYF (val) {
      if (!val) return
      return val.replace('Y', '押').replace('F', '付')
    },
    filterDict (val, opts) {
      if (!val) return
      for (const d of opts) {
        if (d.dictValue == val) {
          return d.dictLabel
        }
      }
    },
    filternumtoname (val_) {
      const val = parseInt(val_)
      if (val === 1) {
        return '面访'
      }
      if (val === 2) {
        return '跟进'
      }
      if (val === 3) {
        return '查看'
      }
      if (val === 4) {
        return '被带看'
      }
      if (val === 5) {
        return '钥匙'
      }
      if (val === 6) {
        return '其他'
      }
      if (val === 8) {
        return '意向'
      }
    }
  }
}
</script>

<style lang="less" scoped>
.btn_svg{
  width:24px;
  height:auto;
}
.preview_cover{
  width:100vw;
  height:100vh;
  background:rgba(0,0,0,0.6);
  position:fixed;
  z-index:99;
  left:0;
  top:0;
  cursor:pointer;
}
.preview_img{
  width:90%;
  height:90%;
  object-fit: contain;
  margin: 5%;
  cursor:pointer;
  border-radius:10px;
  -wekit-border-radius:10px;
}
.preview_video{
  width:90vw;
  height:90vh;
  margin:1vh 5vw auto 5vw ;
  cursor:pointer;
  border-radius:10px;
  -wekit-border-radius:10px;
}
.downLoad {
  cursor: pointer;
  text-align: right;
  color: var(--ThemeColor);
}
.lunbo {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.no_img_wrapper {
  width: 100%;
  height: 200px;
  text-align: center;
}
.no_img {
  width: 300px;
  height: 160px;
  background: #f2f2f2;
  margin: 20px auto 0 auto;
  img {
    width: 300px;
    height: 160px;
  }
}
.img_titlePic {
  background: #f2f2f2;
  width: 100%;
  height: 100%;
}
.detail-t {
  // cursor: pointer;
  .font_red,
  .font_light {
    // color:#ff0000;
    // cursor: pointer;
    // background: #fff1f0;
    color: #f5222d;
    // border: 1px solid #f5222d;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -ms-border-radius: 4px;
    -moz-border-radius: 4px;
    padding: 0 5px;
  }
  .font_light.icon-yuechi {
    cursor: none;
    color: gold;
    background: none;
    border: none;
  }
  .font_gray {
    cursor: pointer;
    color: #ccc;
  }
}
.icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  // margin-right: 20px;
  // cursor: pointer;
  height:100%;
  .icon-i {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    background-color: var(--ThemeColor);
    color: white;
    text-align: center;
    line-height: 45px;
    .iconfont {
      font-size: 20px;
    }
  }
  .icon-ii {
    background-color: #31c170;
  }
}
.unclickColor {
  color: gray !important;
}
.unclickBgc {
  background-color: gray !important;
}
.detaill-img： {
  width: 30px;
  height: 30px;
}
.detail {
  width: 100%;
  padding: 20px;
  background-color: white;

  .detail-center {
    // width: 95%;
    margin: 0 auto;
    header {
      height: 66px;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;

      .title {
        font-size: 20px;
        font-weight: 700;
        color: #222222;
        margin-bottom: 0px;
      }
      .houseBtn {
        // padding: 42px 20px 0 0;
        padding: 0 20px 0 0;
        display: flex;
        position: absolute;

        right: 0;
        .Btnclaim {
          .Claim {
            width: 45px;
            height: 45px;
            line-height: 45px;
            border-radius: 50%;
            background-color: #2fba6c;
            color: white;
            text-align: center;
            cursor: pointer;
            .claim-icom {
              font-size: 22px;
            }
          }
          .clainFont {
            text-align: center;
            color: #2fba6c;
          }
        }
        .btnHouse {
          margin-left: 10px;
          .Claim {
            width: 45px;
            height: 45px;
            line-height: 45px;
            cursor: pointer;
            border-radius: 50%;
            background-color: var(--ThemeColor);
            color: white;
            text-align: center;
            display: flex;
            justify-content: center;
            align-items: center;
            .claim-icom {
              font-size: 22px;
            }
          }
          .clainFont {
            text-align: center;
            color: var(--ThemeColor);
          }
          /deep/.ant-divider-horizontal {
            margin: 9px 0;
          }
        }
      }
    }
    .header {
      height: 80px;
      display: flex;
      align-items: center;

      & > p {
        margin-bottom: 0;
        font-size: 14px;
        font-weight: bold;
        color: black;
      }

      & > img {
        width: 20px;
        height: 20px;
        margin-left: 6px;
        margin-top: 3px;
      }
    }

    & > aside {
      margin-top: 20px;
      /deep/ .ant-tabs-tab {
        margin-right: 0;
        border: none;
        background-color: #ffffff;
        color: black;
        font-size: 14px;
        font-weight: bold;
      }

      /deep/ .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
        font-size: 14px;
        color: var(--ThemeColor);
        font-weight: bold;
      }
      /deep/.ant-tabs-nav {
        margin-top: -2px;
      }
      // .swiper-button-prev, .swiper-container-rtl .swiper-button-next{
      //   height:100%;
      //   top:0;
      //   margin-top:0;
      // }
      .card-container {
        .basicInfor {
          // background-color: #6982f3;
          margin-top: 20px;
          display: flex;
          .basicInfor_left {
            // width:710px;
            width: 58%;
            height: auto;
            .img_big {
              width: 710px;
              // height:400px;
              background: #f2f2f2;
              margin-bottom: 10px;
            }
          }
          .basicInfor_right {
            width: calc(42% - 30px);
            display: flex;
            flex-direction: column;
            margin-left: 30px;
            .follow-up {
              margin-top: 56px;
              margin-bottom: 20px;
              display: flex;
              // border:1px solid #f2f6fc;
              // padding: 20px;
              .title {
                width: 90px;
                font-weight: 700;
              }
              .msg {
                width: calc( 100% - 90px);
                min-width: 200px;
                > div {
                  display: flex;
                  justify-content: space-between;
                }
                .describe {
                  display: flex;
                  flex-wrap: wrap;
                  // width: 400px;
                  overflow: hidden;
                  white-space: normal;
                  word-break: break-all;
                }
                h1 {
                  font-weight: 700;
                }
              }
            }
          }
          .basicInforImg {
            width: 139px;
            height: 137px;
          }
          .basicNew {
            .basicTelte {
              width:100%;
              display: flex;
              flex-direction: column;
              // margin-top: 15px;
              .basicTelteTu {
                display: flex;
                flex-direction: row;
                position: relative;
                // top: -3px;
                width: 200px;
                height: 40px;
                margin:10px 0;
                // background: #f6ffed;
                justify-content: space-around;
                align-items: center;
                // box-shadow: 1px 1px 3px #ccc;
                // -webkit-box-shadow: 1px 1px 3px #ccc;
                // border-radius:3px;
                // -webkit-border-radius:3px;
                .detail-t {
                    width: 40px;
                    height: 40px;
                    text-align: center;
                    vertical-align: middle;
                    line-height: 40px;
                    box-shadow: 1px 1px 3px #ccc;
                    -webkit-box-shadow: 1px 1px 3px #ccc;
                }
                .detail-t:first-child {
                  margin-left: 0;
                }
              }
              .house-basicInfoR-warpper {
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                flex-direction: column;
                .shop_name{
                  font-size: 20px;
                  font-weight: bold;
                  color:#222;
                }
                .basicTeltexi {
                  font-size: 24px;
                  margin-right: 50px;
                  font-weight: bold;
                  color: #222222;
                  line-height: 40px;
                  display: flex;
                  flex-direction: column;
                  .tag_house_status {
                    width: 50px;
                    text-align: center;
                    margin-bottom: 20px;
                  }
                }

                .price {
                  margin-bottom: 20px;
                  .priceInfor {
                    display: flex;
                    align-items: center;
                    .priceHousin {
                      font-size: 16px;
                      font-weight: bold;
                      color: #000;
                    }
                    .priceTag {
                      background: #2fba6c;
                      color: #fff;
                      height: 17px;
                      padding: 0 5px;
                      font-size: 12px;
                      line-height: 17px;
                      margin-top: 2px;
                      margin-left: 7px;
                    }
                    .price_transferFee{
                      margin-left:30px;
                      font-size:14px;
                      color:#222;
                    }
                  }
                  .houseup {
                    font-size: 20px;
                    color: #222222;
                  }
                }
                .dish_tag_area_floor{
                  display:flex;
                  align-items: center;
                  .dish_tag{
                   .dish_type{
                      background: green;
                      color: #fff;
                      border-radius: 10px;
                      -webkit-border-radius: 10px;
                   }
                  }
                  .housArea{
                    margin-left:10px;
                    .areaInfor{
                      font-weight:bolder;
                      color:#222;
                    }
                  }
                }
                .house_special{
                  width:100%;
                  margin:20px 0 0 0;
                }
              }
              .list_info{
                width:100%;
                display: flex;
                flex-direction: column;
                .item_info{
                  width:100%;
                  display: flex;
                  flex-wrap: wrap;
                  flex-direction: row;
                  align-items: center;
                  color:#222;
                  line-height: 30px;
                  margin:0;
                  .item_info_val{
                    margin:0;
                    padding:0;
                    p{
                      margin:0;
                    }
                  }
                }
              }
            }
            .houseTag {
              margin: 10px 0px;
            }

            .houseInfor {
              display: flex;
              flex-direction: column;
              // margin-top: 13px;
              // margin-bottom: 20px;
              .address {
                margin-bottom: 20px;
                .housin {
                  font-size: 14px;
                  font-weight: bold;
                  color: #000;
                }
                .houseup {
                  font-size: 12px;
                  color: #000;
                }
              }

              .housArea {
                margin-right: 20px;
                .areaInfor {
                  font-size: 14px;
                  font-weight: bold;
                  color: #000;
                }
                .houseup {
                  font-size: 12px;
                  color: #000;
                }
              }
            }
          }

          .first-col {
            cursor: pointer;

            & > img {
              width: 200px;
              height: 200px;
              border-radius: 10px;
            }
          }

          /deep/ .ant-col-10 {
            margin-top: 28px;
          }

          .second-col {
            height: 100%;
            cursor: pointer;

            & > ul {
              list-style: none;

              & > li {
                &:nth-of-type(1) {
                  width: 280px;
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  margin-top: 20px;

                  & > span {
                    font-size: 14px;
                    color: black;
                    font-weight: bold;
                  }

                  & > img {
                    width: 18px;
                    height: 18px;
                    margin-top: 6px;
                  }
                }

                &:nth-of-type(2) {
                  margin-top: 20px;

                  & > span {
                    display: inline-block;
                    width: 46px;
                    height: 28px;
                    font-size: 12px;
                    border-radius: 5px;
                    line-height: 28px;
                    text-align: center;
                    margin-right: 10px;
                  }

                  & > .green {
                    border: 1px solid #7ac756;
                    color: #7ac756;
                    background-color: #eef8e8;
                  }

                  & > .orange {
                    border: 1px solid var(--ThemeColor);
                    color: var(--ThemeColor);
                    background-color: #fdf5e9;
                  }

                  & > .red {
                    border: 1px solid #f26161;
                    color: #f26161;
                    background-color: #feeeee;
                  }
                }

                &:nth-of-type(3) {
                  // width: calc(100% - 280px - 6%);
                  margin-top: 20px;
                  color: black;

                  p {
                    &:first-of-type {
                      margin-bottom: 0px;
                      font-weight: bold;
                      font-size: 14px;
                    }
                  }

                  .mid-span {
                    display: flex;
                    align-items: center;

                    & > p {
                      margin-bottom: 0px;
                    }

                    & > span {
                      width: 53px;
                      height: 17px;
                      background-color: #2fba6c;
                      color: white;
                      line-height: 17px;
                      text-align: center;
                    }
                  }
                }
              }
            }
          }

          .last-col {
            cursor: pointer;

            & > ul {
              width: 86%;
              list-style: none;
              display: flex;
              justify-content: space-between;
              margin-top: 20px;
              margin-left: 86px;

              & > li {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                & > span {
                  display: inline-block;
                  width: 70px;
                  height: 70px;
                  background-color: var(--ThemeColor);
                  border-radius: 50%;
                }
              }
            }
          }
        }

        /* .swiper-button-prev {
          color: rgba(0, 0, 0, 0) !important;
        }
        .swiper-button-next {
          color: rgba(0, 0, 0, 0) !important;
          background: url('../detail/right.png') center center no-repeat;
        }
        .swiper-button-prev {
          color: rgba(0, 0, 0, 0) !important;
          background: url('../detail/left.png') center center no-repeat;
        }
        .swiperbox {
          position: initial;
        } */
        .lunbo {
          width: 100%;
          //height: 260px;
          margin-top: 40px;
          display: flex;
          align-items: center;
          position: relative;
          padding: 0 50px;
          & > .lunbo-child {
            margin: 0 auto;
            width: 93%;
            height: 100%;
            background-color: white;
            flex-shrink: 1;
            overflow: hidden;
            display: flex;
            justify-content: space-between;

            & > img {
              height: 100%;
              // width: 400px;
              width: 100%;
              margin-right: 10px;
              flex-shrink: 1;
            }
          }
        }
        .botText {
          display: flex;
          width: 220px;
          justify-content: space-between;
          padding-top: 30px;
          padding-bottom: 10px;

          & > p {
            &:nth-of-type(1) {
              font-size: 14px;
              color: black;
            }

            &:nth-of-type(2) {
              font-size: 14px;
              color: var(--ThemeColor);
              font-weight: bold;
            }

            &:nth-of-type(3) {
              font-size: 14px;
              color: var(--ThemeColor);
              font-weight: bold;
            }
          }
        }
        .houseSiwper {
          margin-top: 15px;
          .ant-carousel /deep/ .slick-slide {
            text-align: center;
            height: 200px;
            line-height: 200px;
            background: #79d3df;
            overflow: hidden;
          }
          .ant-carousel /deep/ .custom-slick-arrow {
            width: 25px;
            height: 25px;
            font-size: 14px;
            color: #fff;
            background-color: rgba(31, 45, 61, 0.11);
            opacity: 0.3;
          }
          .ant-carousel /deep/ .custom-slick-arrow:before {
            display: none;
          }
          .ant-carousel /deep/ .custom-slick-arrow:hover {
            opacity: 0.5;
          }

          .ant-carousel /deep/ .slick-slide h3 {
            color: #fff;
          }
        }
        .inforCenter {
          border-top: 2px solid #f2f6fc;

          & > p {
            font-size: 14px;
            font-weight: bold;
            color: black;
            padding-top: 20px;
          }

          .botInfo {
            /deep/ p {
              font-size: 14px;
              margin-bottom: 8px;

              &:nth-of-type(1) {
                color: #666;
                font-size: 14px;
              }

              &:nth-of-type(2) {
                color: black;
                font-weight: bold;
                font-size: 14px;
              }

              & > span {
                color: var(--ThemeColor);
              }
            }

            /deep/ .ant-row {
              margin-bottom: 20px;
            }
          }

          padding-bottom: 20px;
        }

        .remark {
          width: 100%;
          height: 200px;
          border: 2px solid #f2f6fc;
          border-radius: 3px;
          -webkit-border-radius: 3px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          align-items: center;
        }
        .house_intro_remark{
          width:100%;
          height:auto;
          display:flex;
          justify-content: space-around;
          .textarea_info{
             width:48%;
             height:auto;
             .title{
              color:#222;
              font-size:16px;
              font-weight: 700;
              cursor:pointer;
             }
             .con{
              width:96%;
              height:120px;
              padding:10px 2%;
              line-height:30px;
              // border:1px solid var(--ThemeColor);
              border-radius:8px;
              -webkit-border-radius:8px;
              overflow: scroll;
               box-shadow: 1px 1px 3px var(--ThemeColor);
              -webkit-box-shadow: 1px 1px 3px var(--ThemeColor);
             }
          }
        }
        .bot-detail {
          margin: 40px 0 0 0px;
          width: 100%;
          border-top: 2px solid #f2f6fc;

          /deep/ .ant-col-12 {
            display: flex;
            align-items: center;
            padding-top: 20px;
            // padding-bottom: 20px;

            p {
              font-size: 16px;
              color: #222222;
              margin-right: 20px;
              font-weight: 700;
              display: inline-block;
              margin-bottom: 0;
            }

            span {
              font-size: 14px;
              color: var(--ThemeColor);
              font-weight: bold;
              margin-right: 10px;
            }
          }

          .bot-detail-bot {
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 40px;

            .bot-detail-left {
              width: 49.5%;
              // height: 734px;
              height: auto;
              padding-bottom: 30px;
              border-radius: 3px;
              -webkit-border-radius: 3px;
              border: 2px solid #f2f6fc;
              display: flex;
              justify-content: center;

              .bot-detail-left-center {
                width: 91%;
                padding-top: 30px;
                & > ul {
                  // width: 80%;
                  list-style: none;
                  margin: 0 auto;
                  display: flex;
                  // justify-content: space-between;
                  // justify-content: space-around;
                  align-items: center;
                  // margin-left: 49px;
                  padding-left: 0px;
                  .show {
                    width: 70px;
                    height: 30px;
                    background-color: var(--ThemeColor);
                    border-radius: 30px;
                    line-height: 30px;
                    margin-right: 25px;
                    text-align: center;
                    color: white;
                  }
                  & > li {
                    width: 70px;
                    height: 30px;
                    background-color: #cccccc;
                    border-radius: 30px;
                    line-height: 30px;
                    margin-right: 25px;
                    text-align: center;
                    color: white;
                  }
                }
                .child-bot {
                  margin-top: 20px;
                  .row {
                    padding-bottom: 10px;
                    padding-top: 10px;
                    border-bottom: 1px solid #f2f6fc;
                    display: flex;
                    .col-one {
                      margin-right: 10px;
                    }
                    .col-two {
                      flex: 1;
                      .flex-warp {
                        word-break: break-all;
                      }
                    }
                    .col-three {
                      width: 140px;
                    }
                  }
                }
              }
            }

            .bot-detail-right {
              width: 49.5%;
              // padding: 30px 0 0 2px;
              border-radius: 3px;
              -webkit-border-radius: 3px;
              border: 2px solid #f2f6fc;
              // margin-right: 41px;

              .right-center {
                img {
                  width: 64px;
                  height: 64px;
                  border-radius: 64px;
                  -webkit-border-radius: 64px;
                  // margin-top: 20px;
                  margin-top: 8px;
                }
                width: 94%;
                margin: 0 auto;
                /deep/ .ant-row {
                  // margin-bottom: 30px;
                  border-bottom: 1px solid #f2f6fc;
                  padding-bottom: 15px;
                  padding-top: 15px;
                }

                /deep/.ant-col-4 {
                  & > img {
                    width: 90px;
                    height: 90px;
                    border-radius: 100px;
                  }
                }

                /deep/.ant-col-20 {
                  & > p {
                    &:nth-of-type(1) {
                      font-size: 14px;
                      color: black;
                      font-weight: bold;
                      margin-top: 14px;
                    }

                    &:nth-of-type(2) {
                      font-size: 14px;
                      color: black;

                      & > span {
                        font-size: 14px;
                        font-weight: normal;
                        color: #c2c1bf;
                        margin-left: 20px;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  & > #lookModel {
    /deep/#lookUl {
      list-style: none;
      display: flex;
      justify-content: center;

      & > li {
        & > img {
          width: 200px;
          height: 200px;
          border-radius: 200px;
        }

        &:nth-of-type(2) {
          list-style: none;
          display: flex;
          flex-direction: column;
          align-items: center;
        }
      }
    }
  }

  .uploads {
    /deep/.ant-upload.ant-upload-select-picture-card {
      width: 150px;
      height: 150px;
    }
    .avatar-uploader > .ant-upload {
      width: 328px;
      height: 328px;
    }

    .ant-upload-select-picture-card i {
      font-size: 32px;
      color: #999;
    }

    .ant-upload-select-picture-card .ant-upload-text {
      margin-top: 8px;
      color: #666;
    }
  }
  .state {
    width: 50px;
    height: 50px;
    background: #ccc;
    color: #fff;
    border-radius: 50%;
    text-align: center;
    line-height: 50px;
    // margin-top: 15px;
    margin-top: 8px;
  }

  .editdept {
    display: flex;
    padding-left: 15px;
    justify-content: space-between;
  }

  .department {
    padding-top: 12px;
    font-size: 14px;
    color: black;
    font-weight: bold;
    margin-bottom: 10px;
    padding-left: 15px;
  }
}
.look {
  display: flex;
  .owner {
    width: 95px;
    height: 95px;
    border-radius: 50%;
    background-color: var(--ThemeColor);
    line-height: 95px;
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    color: #fff;
    margin-right: 10px;
  }
  p {
    font-size: 16px;
    font-weight: 600;
    color: #222222;
    margin-left: 20px;
  }
  .msg {
    div {
      padding-top: 20px;
    }
  }
}

.Model {
  width: 200px;
  height: 200px;
  border: 1px solid #e8e8e8;
  position: absolute;
  z-index: 999;
  background: #fff;
  top: 89px;
  right: 0;
  #components-popover-demo-placement .ant-btn {
    width: 70px;
    text-align: center;
    padding: 0;
    margin-right: 8px;
    margin-bottom: 8px;
  }
}
.gdicon {
  .Moeldtb {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    background-color: var(--ThemeColor);
    color: white;
    text-align: center;
    line-height: 45px;
    cursor: pointer;
  }
  .Moeld {
    text-align: center;
    color: var(--ThemeColor);
  }
  .topcenter {
    position: fixed;
    top: 9%;
    left: 26%;
  }
}
.Img {
  display: flex;
}
.interview-textarea {
  margin-top: 20px;
  width: 100%;
  height: 90px;
  outline: none;
  border-radius: 10px;
  border-color: #f1f2f3;
  padding: 10px;
  margin-bottom: 20px;
  resize: none;
  overflow: hidden;
}
</style>

<style scoped>
.box {
  width: 100%;
  position: relative;
  background-color: #fff;
  /* padding-top: 40px; */
}
.swiper-container {
 position:relative;
}
.swiper-box {
  /* width: 960px; */
  width: 100%;
  margin: auto;
}
.gallery-top {
  height: 80% !important;
  width: 100%;
}
.gallery-thumbs {
  height: 20% !important;
  box-sizing: border-box;
  padding: 10px 0;
  /* width: 82%; */
  width: 100%;
}
.gallery-thumbs .swiper-slide {
  width: 25%;
  height: 100%;
  /* opacity: 0.4; */
  opacity: 1;
}
.gallery-thumbs .swiper-slide-active {
  opacity: 1;
}
.swiper-slide {
  text-align: center;
  height: 500px;
  display: flex;
  transition: 300ms;
  /* transform: scale(0.6); */
  transform: scale(1);
  /* opacity: 0.3; */
  opacity: 1;
}
.swiper-slide-active,
.swiper-slide-duplicate-active {
  transform: scale(1);
}
.swiper-slide-next {
  /* opacity: 0.7; */
  opacity: 1;
  /* transform: scale(0.8); */
  transform: scale(1);
  z-index: 998 !important;
}
.swiper-slide-prev {
  /* opacity: 0.7; */
  opacity: 1;
  /* transform: scale(0.8); */
  transform: scale(1);
}
.swiper-slide-active {
  opacity: 1;
  z-index: 999 !important;
}
.swiper-button-prev.swiper-button-white,
.swiper-button-next.swiper-button-white {
  --swiper-navigation-color: #999 !important;
  /* top: 330px; */
}
.gallery-thumbs .swiper-slide {
  height: 120px !important;
}
.gallery-thumbs .swiper-slide-active {
  border: 4px solid #006c95;
}
.swiper-thumbs-prev,.swiper-thumbs-next{
  position: absolute;
  z-index: 99;
  top: 10px;
  width: 27px;
  height: 120px;
  background: rgba(0,0,0,0.8)
}
.swiper-thumbs-next {
  left: 0px;
}
.swiper-thumbs-prev {
  right: 0px;
}
.bottom-box {
  width: 100%;
  height: 400px;
  position: relative;
  margin-top: 40px;
}
.bottom-b-img {
  width: 100%;
  height: 100%;
  position: absolute;
}
.bottom-b-color {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 2;
  background: rgba(0, 108, 149, 0.6);
  display: flex;
  align-items: center;
}
.bottom-img {
  width: 400px;
  height: 100px;
  margin: auto;
}
.swiper-slide[data-v-7292165a] {
  height: 370px;
}
.btn_more{
  color: black;
  text-align: center;
  /* border-bottom:1px solid #f2f2f2; */
}
.btn_more:hover{
  color:var(--ThemeColor)
}
.swiper-show_video,.swiper-show_img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
